import React, { useEffect, useState } from "react";
import { convertFromWei, convertFromWeiEthers, convertToMwei, epochToDateFormate, formatNumberWithCommas, formatSmartDecimal, generateProfileShareMessage, getTokenSymbol, shareProfileEmail, shareProfiletoSocials, truncateLongTexts } from '../../utils/helpers'
import { arbiscan_url, facebook_url, IS_AQUA_SWAP_DEPOSIT_ACTIVE, RAIN_ARBI_CONTRACT_ADDRESS, telegram_url, twitter_url, USDT_SYMBOL, whatsapp_url } from '../../utils/Enviroment';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal, Offcanvas, Tooltip, Dropdown } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "./mycreatedpolls.scss";
import axios from "axios";
import { ALCHEMY_API_KEY, api_url, IPFS_GATEWAY, IS_AQUA_SWAP_WITHDRAW_ACTIVE, IS_DISTRIBUTING_POINT_OPEN, rain_twitter_url, usdt_token } from "../../utils/Enviroment";
import useWeb3 from "../../hooks/useWeb3";
// import { useWeb3React } from "@web3-react/core";
import Loader from "../../hooks/loader";
import WinnerCheck from "../../hooks/dataFetcher/WinnerCheck";
import PercentageOptions from "../../hooks/dataFetcher/PercentageOptions";
import useSocket from "../SocketIo";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil";
import { userAccountUsdtBalance, userSmartAccountUsdtBalance, userSmartAccountRainBalance, userSmartAccount, userSmartAccountClient, userTotalRewardPoints, userProfileData, rainPriceInUsdt } from "../RecoilAtom";
import { QRCodeCanvas } from 'qrcode.react';
import { TOKEN_ETH, TOKEN_USDT, TOKEN_RAIN, QR_CODE_SIZE, USDT_LOGO_SIZE, INVITE, REFERRAL_POINTS, DEPOSIT, WITHDRAW, PERCENTAGE_OF_POINTS, USDT_MOCK_VALUE, aquaTokens, CHAIN_BSC, TOKEN_BNB, CHAIN_ARBITRUM, CHAIN_TO_TOKEN_ADDRESSES, AQUA_SWAP_TX_STATUS, aquaChains, MIN_AMOUNT_PER_TOKEN, TIMEOUT, NETWORK_FEES, LIGHT_THEME, DEFAULT_TOKEN, DEFAULT_CHAIN, marketFilterOptions, LIVE } from "../../utils/constants";
import { DepositViaWalletOrAddress, DepositViaAddress, DepositViaAccount, DepositSuccess } from "../Deposit"
import { useTransfer } from "../../hooks/dataSender/Transfer";
import { handleDeposit, handleCopy, handleToFixedOnDecimals, isEthereumWalletAddress, getFormatedWeb3Address, validateLink, handleGasFeeWithBuffer, sendGasFeeAsUsdt, formatNumbers, handleCheckSession, getChainByKey, getTokenByKey, renderOptions } from "../../utils/helpers";
import { useWithdrawalAmountHook } from '../../hooks/dataSender/WithdrawalAmount'
import { useGetAllBalances } from "../AllBalances";
import { encodeFunctionData } from "viem";
import TradePoolAbi from '../../utils/TradePoolAbi.json'
import { signPreparedCalls } from "@account-kit/wallet-client";
import { aquaSwapWalletGeneration, ethToDollarConverter, getFollowersList, getFollowingList, getFollowStats, getGeneratedProfilePreview, getOpenInterest, getProfileTotalVolume, getUsersPnlGraph, postUserReferralPoints, postUserRewardPoints, uploadProfilePicture } from "../../utils/services";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import { getUsersProfile } from "../../utils/services";
import { Network, Alchemy } from 'alchemy-sdk';
import ProgressiveProgressBar from "../ProgressiveProgressBar";
import { notifyError, notifySuccess, notifyWarning } from "../Toast";
import { useTheme } from "../../contexts/ThemeProvider";
import { useSocketEvents } from "../../hooks/dataFetcher/AquaSocket";
import { DEFAULT_ERROR_HEADING, FUNDS_RECIEVED_SUCCESS, GAS_FEES_ERROR, MARKET_CLOSE_WARNING, PROFILE_UPDATE_SUCCESS, SWAP_REFUND_WARNING } from "../../utils/ConstantMessages";
import { MARKET_STATUS, MARKET_STATUS_BACKGROUNDS, MARKET_STATUS_TEXT_COLORS } from "../../utils/MarketStatus";
import PoolTimerUI from "../DetailPage/PoolTimerUI";
import CustomPagination from "../CustomPagination";
import HistoryTable from "./HistoryTable";
import Followers from "./Followers";
import Following from "./Following";
import MyPredictedMarkets from "./MyPredictedMarkets";
import YearAreaChart from "./YearAreaChart";
import useBalance from "../../hooks/dataFetcher/BalanceOf";
import { useEoaAccount } from "../../hooks/useEoaAccount";
import { callCrashGameGraphQLQuery } from "../../hooks/crashHooksdummy/axiosClient";

import BalanceOfAbi from "../../utils/BalanceOfAbi.json";
import { Helmet } from "react-helmet-async";

const Mycreatedpolls = () => {
  const { theme } = useTheme();
  const { pools, setPools } = useSocket();
  const { t } = useTranslation();
  const location = useLocation();
  const [startProgressBar, setStartProgressBar] = useState(false);
  const [show3, setShow3] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = async (address, option) => {
    if (USDT_MOCK_VALUE > +smartAccountUsdtBalance) {
      notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
      return;
    }
    const callArgs = [
      {
        to: address,
        data: encodeFunctionData({
          abi: TradePoolAbi,
          functionName: 'chooseWinner',
          args: [option]
        }),
      },
      {
        to: usdt_token,
        data: sendGasFeeAsUsdt(USDT_MOCK_VALUE)
      }
    ]
    const gasFee = await handleGasFeeWithBuffer(smartAccount, callArgs, alchemy)
    setGasEstimateInUsdt(gasFee)
    setShow3(true)
  };
  const web3 = useWeb3();
  const { account } = useEoaAccount();
  const [show6, setShow6] = useState(false);
  const [activeKey, setActiveKey] = useState("History");
  const handleClose6 = async () => {
    setShow6(false);
    await getPoolsByCreator(1, "privatePools");
  };
  const handleShow6 = () => setShow6(true);
  const [show5, setShow5] = useState(false);
  const handleClose5 = async () => {
    setShow5(false);
    await getPoolsByCreator(1, "privatePools");
  };
  const handleShow5 = () => setShow5(true);
  const [userprofile, setUserProfile] = useRecoilState(userProfileData);
  const [totalpnl, setTotalPnl] = useState([]);
  const [name, setName] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [telegramUrl, setTelegramUrl] = useState("");
  const [withdrawalAddress, setWithdrawalAddress] = useState("");
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [DiscordUrl, setDiscordUrl] = useState("");
  const [profilepic, setProfilePic] = useState("");
  const smartAccountClient = useRecoilValue(userSmartAccountClient)
  const [publicpools, setPublicPools] = useState([]);
  const { withdrawalAmountTransaction } = useWithdrawalAmountHook();
  const { WinnerCheckHook } = WinnerCheck();
  const [isTableLoading, setIsTableLoading] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const [isCopied, setIsCopied] = useState(false);
  const [isReferralCopied, setIsReferralCopied] = useState(false);
  const [poolsdetail, setPoolsDetail] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // State to track the selected option
  const [selectedname, setSelectedName] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(3); // Set a default value of pages
  const [totalCount, setTotalCount] = useState(0);
  const [winnercheck, setWinnerCheck] = useState(0);
  const [message, setMessage] = useState("");
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);
  const [show8, setShow8] = useState(false);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);
  const [show9, setShow9] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => setShow9(true);
  const handleCloseShareProfileModal = () => setShowProfileModal(false);
  const handleShoweShareProfileModal = () => setShowProfileModal(true);
  const { PercentageOptionsHook } = PercentageOptions();
  const [percentageoption, setPercentageOption] = useState("");
  const [percentageindiv, setPercentageIndivi] = useState("");
  const [totalprediction, setTotalPrediction] = useState("");
  const [withdrawalToken, setWithdrawalToken] = useState(TOKEN_USDT);
  const [withdrawalRequest, setWithdrawalRequest] = useState(false);
  const [aquaRequest, setAquaRequest] = useState(false);
  const [aquaResponseMessage, setAquaResponseMessage] = useState("");
  const [withdrawalTokenImage, setWithdrawalTokenImage] = useState("/assets/usdticon.png");
  const [portfolioAmount, setPortfolioAmount] = useState("");
  const api_key = "2318bd9b1ee9b9a732ca";
  const secret_key = "78029869855f6acdef83f4ad97ae6b5a0a1afae8146ee9a086394ae612810731";
  const rainPriceInDollar = useRecoilValue(rainPriceInUsdt);
  const smartAccount = useRecoilValue(userSmartAccount);
  const transferFunds = useTransfer()
  const [selectedToken, setSelectedToken] = useState(TOKEN_USDT);
  const [selectedChain, setSelectedChain] = useState(IS_AQUA_SWAP_DEPOSIT_ACTIVE ? DEFAULT_CHAIN : "Arbitrum");
  const [selectedTokenWithdraw, setSelectedTokenWithdraw] = useState(IS_AQUA_SWAP_WITHDRAW_ACTIVE ? DEFAULT_TOKEN : TOKEN_USDT);
  const [selectedChainWithdraw, setSelectedChainWithdraw] = useState(IS_AQUA_SWAP_WITHDRAW_ACTIVE ? DEFAULT_CHAIN : "Arbitrum");
  const [depositAmount, setDepositAmount] = useState("");
  const [selectedTokenConfig, setSelectedTokenConfig] = useState(null);
  const [showDepositAccOrAddr, setShowDepositAccOrAddr] = useState(false);
  const [showDepositViaAddress, setShowDepositViaAddress] = useState(false);
  const [showDepositViaAccount, setShowDepositViaAccount] = useState(false);
  const [showDepositSuccess, setShowDepositSuccess] = useState(false);
  const [isDepositing, setIsDepositing] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const handleCloseWithdraw = () => { setShowWithdraw(false); setAquaRequest(false); setAquaResponseMessage("") };
  const handleShowWithdraw = () => {
    setShowWithdraw(true)
  };
  const getAllBalances = useGetAllBalances();
  const [showComplete, setShowComplete] = useState(false);
  const handleCloseComplete = () => { setShowComplete(false); setWithdrawalAddress(""); setWithdrawalAmount(""); getAllBalances() };
  const handleShowComplete = () => setShowComplete(true);
  const [showFailed, setShowFailed] = useState(false);
  const handleCloseFailed = () => setShowFailed(false);
  const handleShowFailed = () => setShowFailed(true);
  const accountUsdtBalance = useRecoilValue(userAccountUsdtBalance);
  const [depositBalance, setDepositBalance] = useState(accountUsdtBalance);
  const smartAccountUsdtBalance = useRecoilValue(userSmartAccountUsdtBalance);
  const smartAccountRainBalance = useRecoilValue(userSmartAccountRainBalance);
  const setSmartAccountUsdtBalance = useSetRecoilState(userSmartAccountUsdtBalance);
  const [pointsHistory, setPointsHistory] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { grantPermissions } = useSessionPermissions()
  const [gasEstimateInUsdt, setGasEstimateInUsdt] = useState("")
  const [pnlGraphData, setPnlGraphData] = useState([])
  const [filterGraphData, setFilterGraphData] = useState("all")
  const [graphPnl, setGraphPnl] = useState("all")
  const [aquaSwapAddress, setAquaSwapAddress] = useState('');
  const [aquaEvents, setAquaEvents] = useState([]);
  const [pollStatus, setPollStatus] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [volumeProfile, setVolumeProfile] = useState("");
  const [profileFollowers, setProfileFollowers] = useState([]);
  const [profileFollowing, setProfileFollowing] = useState([]);
  const [followStats, setFollowStats] = useState({});
  const [isMarketFilterOpen, setMarketFilterOpen] = useState(false);
  const [selectedMarketFilter, setSelectedMarketFilter] = useState(LIVE);
  const [openInterest, setOpenInterest] = useState("");
  const { getTokenBalance } = useBalance();
  const [crashmbltab, setCrashMblTab] = useState("activity");
  const [estimatedGasFee, setEstimatedGasFee] = useState(0);
  const [estimatingGas, setEstimatingGas] = useState(false);
  const [mergedBetHistory, setMergedBetHistory] = useState([]);
  const [playerBetHHistory, setPlayerBetHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [recentGamesData, setRecentGamesData] = useState([]);
  const [playerHistory, setPlayerHistory] = useState([]);
  const [withdrawGasFeeEstimate, setWithdrawGasFeeEstimate] = useState(0);

  const toggleMarketFilter = (isOpen) => setMarketFilterOpen(isOpen);
  const handleMarketFilterSelect = async (filter) => {
    setSelectedMarketFilter(filter);
    setMarketFilterOpen(false);
  };

  const settings = {
    apiKey: ALCHEMY_API_KEY,
    network: Network.ARB_MAINNET,
  };
  const alchemy = new Alchemy(settings);

  useEffect(() => {
    if (account && smartAccount && accessToken) {
      (async () => {
        await getAllBalances();
        await getUsersProfile();
        await getTotalPnl()
        await getTotalPredictions()
      })();
    }
  }, [account, smartAccount, accessToken]);

  const formatLabel = (date, timePeriod) => {
    switch (timePeriod) {
      case "day":
        return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
      case "week":
      case "month":
      case "all":
      default:
        return `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}`;
    }
  };

  const fetchOwnerBetHistory = async (timePeriod = "all") => {
    const closePositionQuery = `
      query closePositionTerminations {
        closePositionTerminations(where: { user: "${smartAccount}" }
    orderBy: blockTimestamp
    orderDirection: asc
    first: 1000) {
           user
    transactionHash
    timeElapsedMs
    settlement
    positionId
    marketIndexTermination
    id
    closePositionTimeMs
    blockTimestamp
    blockNumber
        }
      }
    `;

    const openPositionQuery = `
      query openPositionTerminations {
        openPositionTerminations(where: { user: "${smartAccount}"}
        orderBy: blockTimestamp
          orderDirection: asc
          first: 1000) {
          marketIndexTermination
          amount
          blockTimestamp
          transactionHash
          blockNumber
          user
          positionId
        }
      }
    `;

    try {
      const [closePositionData, openPositionData] = await Promise.all([
        callCrashGameGraphQLQuery(closePositionQuery),
        callCrashGameGraphQLQuery(openPositionQuery),
      ]);

      let closePositions = closePositionData?.closePositionTerminations || [];
      let openPositions = openPositionData?.openPositionTerminations || [];

      // 👉 Calculate time threshold based on period
      const now = Math.floor(Date.now() / 1000); // Current timestamp in seconds
      let timeThreshold = 0;

      switch (timePeriod) {
        case "day":
          timeThreshold = now - 24 * 60 * 60; // Last 24 hours
          break;
        case "week":
          timeThreshold = now - 7 * 24 * 60 * 60; // Last 7 days
          break;
        case "month":
          timeThreshold = now - 30 * 24 * 60 * 60; // Last 30 days
          break;
        case "all":
        default:
          timeThreshold = 0; // No filter
          break;
      }

      // 👉 Filter data based on time period
      if (timePeriod !== "all") {
        closePositions = closePositions.filter(
          (pos) => Number(pos.blockTimestamp) >= timeThreshold
        );
        openPositions = openPositions.filter(
          (pos) => Number(pos.blockTimestamp) >= timeThreshold
        );
      }

      // Calculate total PnL
      const totalAmountFromPlaced = openPositions.reduce((sum, bet) => {
        const amount = parseFloat(
          web3.utils.fromWei(bet?.amount || "0", "mwei")
        );
        return sum + amount;
      }, 0);

      const totalAmountFromResolved = closePositions.reduce((sum, bet) => {
        const amount = parseFloat(
          web3.utils.fromWei(bet?.settlement || "0", "mwei")
        );
        return sum + amount;
      }, 0);

      const netProfit = totalAmountFromResolved - totalAmountFromPlaced;
      setGraphPnl(netProfit);

      // 👉 Build graph data from closePositions (resolved trades)
      const closedGraphData = closePositions.map((closePos) => {
        const openPos = openPositions.find(
          (op) => op.positionId === closePos.positionId
        );

        const amountPlaced = openPos
          ? parseFloat(web3.utils.fromWei(openPos.amount || "0", "mwei"))
          : 0;
        const settlement = parseFloat(
          web3.utils.fromWei(closePos.settlement || "0", "mwei")
        );
        const pnl = settlement - amountPlaced;

        const date = new Date(Number(closePos.blockTimestamp) * 1000);

        return {
          label: formatLabel(date, timePeriod),
          pnl,
          timestamp: date.toISOString(),
          blockTimestamp: Number(closePos.blockTimestamp),
        };
      });

      // 👉 Include open positions that have NO matching close position (pure losses)
      const closedPositionIds = new Set(closePositions.map((cp) => cp.positionId));

      const openOnlyGraphData = openPositions
        .filter((op) => !closedPositionIds.has(op.positionId))
        .map((openPos) => {
          const amountPlaced = parseFloat(
            web3.utils.fromWei(openPos.amount || "0", "mwei")
          );
          const pnl = -amountPlaced; // No settlement = full loss

          const date = new Date(Number(openPos.blockTimestamp) * 1000);

          return {
            label: formatLabel(date, timePeriod),
            pnl,
            timestamp: date.toISOString(),
            blockTimestamp: Number(openPos.blockTimestamp),
          };
        });

      // 👉 Merge both arrays
      const graphData = [...closedGraphData, ...openOnlyGraphData];

      // Sort by timestamp (oldest to newest for graph)
      const sortedGraphData = graphData.sort(
        (a, b) => a.blockTimestamp - b.blockTimestamp
      );

      // 👉 Add cumulative overall PnL
      let cumulativePnl = 0;
      const graphDataWithOverallPnl = sortedGraphData.map((item) => {
        cumulativePnl += item.pnl;
        return {
          label: item.label,
          pnl: item.pnl,
          overallPnl: cumulativePnl,
          timestamp: item.timestamp,
        };
      });
      setPnlGraphData(graphDataWithOverallPnl);
    } catch (error) {
      console.error("🚨 Failed to fetch bet history:", error);
    }
  };
  const fetchPlayerHistory = async () => {
    const query = `
      query closePositionTerminations {
        closePositionTerminations(where: { user: "${smartAccount}" }
        orderBy: blockTimestamp
     orderDirection: asc
     first: 1000) {
        user
    transactionHash
    timeElapsedMs
    settlement
    positionId
    marketIndexTermination
    id
    closePositionTimeMs
    blockTimestamp
    blockNumber
    
        }
      }
    `;
    try {
      const data = await callCrashGameGraphQLQuery(query);
      const allPosition = data?.closePositionTerminations || [];
      const sortedHistory = allPosition?.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );

      setPlayerHistory(sortedHistory);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch position history:", error);
      setLoading(false);
    }
  };

  const fetchPlayerBetHistory = async () => {
    const placedBetsQuery = `
    query openPositionTerminations {
      openPositionTerminations(where: { user: "${smartAccount}" }
      orderBy: blockTimestamp
      orderDirection: asc
      first: 1000
      ) {
        marketIndexTermination
        amount
        blockTimestamp
        transactionHash
        blockNumber
        blockTimestamp
        user
        positionId
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(placedBetsQuery);
      const allPosition = data?.openPositionTerminations || [];
      const sortedHistory = allPosition?.sort(
        (a, b) => Number(b.blockTimestamp) - Number(a.blockTimestamp)
      );
      setPlayerBetHistory(sortedHistory);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch position history:", error);
      setLoading(false);
    }
  };
  const fetchGraphChartsData = async () => {
    const query = `
    query finalizeMarketTerminations {
      finalizeMarketTerminations(first: 1000, orderBy: blockNumber, orderDirection: desc) {
        transactionHash
        marketIndexTermination
        random
      }
    }
  `;

    try {
      const data = await callCrashGameGraphQLQuery(query);
      const allRound = data?.finalizeMarketTerminations || [];
      setRecentGamesData(allRound);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch graph chart data:", error);
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!playerHistory?.length && !playerBetHHistory?.length) return;
    const resolvedIndexSet = new Set(playerHistory?.map((bet) => bet?.marketIndexTermination));
    const merged = [];
    playerBetHHistory?.forEach((placedBet) => {
      if (resolvedIndexSet.has(placedBet.marketIndexTermination)) {
        const winBet = playerHistory?.find(
          (resolved) => resolved.marketIndexTermination === placedBet?.marketIndexTermination
        );

        if (winBet) {
          merged.push({
            ...winBet,
            type: "win",
            amount: placedBet?.amount
          });
        }
      } else {
        merged.push({
          ...placedBet,
          type: "loss",
        });
      }
    });
    setMergedBetHistory(merged);
  }, [playerHistory, playerBetHHistory]);
  useEffect(() => {
    if (smartAccount) {
      fetchOwnerBetHistory(filterGraphData);
    }
  }, [smartAccount, filterGraphData]);
  useEffect(() => {

    if (smartAccount) {
      fetchPlayerHistory();
      fetchPlayerBetHistory();
      fetchGraphChartsData();
    } else {
      fetchGraphChartsData();
    }

  }, [smartAccount]);
  useEffect(() => {
    if (account && smartAccount) {
      (async () => {
        let selectedCurrency;
        if (selectedToken === TOKEN_USDT) {
          selectedCurrency = { tokenAddress: usdt_token, tokenDecimals: 6 };
        } else if (selectedToken === TOKEN_RAIN) {
          selectedCurrency = { tokenAddress: RAIN_ARBI_CONTRACT_ADDRESS, tokenDecimals: 18 };
        }
        setSelectedTokenConfig(selectedCurrency);
        const accountBalance = await getTokenBalance(
          selectedCurrency?.tokenAddress,
          account,
          selectedCurrency?.tokenDecimals
        );
        setPortfolioAmount(+smartAccountUsdtBalance);
        setDepositBalance(accountBalance);
      })();
    }
    else {
      setPortfolioAmount("");
      setSmartAccountUsdtBalance("")
    }
  }, [smartAccount, smartAccountUsdtBalance, selectedToken, smartAccountRainBalance, rainPriceInDollar]);

  useEffect(() => {
    if (location.state?.openHistoryTab) {
      setActiveKey("History");
      const mainTabsContainer = document.querySelector(".tabsmain");
      if (mainTabsContainer) {
        mainTabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);

  const depositUsdtOrEth = async () => {
    const depositData = await handleDeposit({
      transferFunction: transferFunds,
      amount: depositAmount,
      tokenConfig: selectedTokenConfig,
      balance: depositBalance,
      toAddress: smartAccount,
      setIsLoading: setIsDepositing,
      onSuccess: () => {
        setShowDepositSuccess(true);
        setShowDepositViaAccount(false);
        setShowDepositAccOrAddr(false);
      },
      onError: (err) => console.log("Custom error handler:", err)
    });
    if (depositData && userprofile?.referredBy && !userprofile?.isSuccessfullyOnboarded && IS_DISTRIBUTING_POINT_OPEN) {
      const payload = {
        eventType: INVITE,
        value: "0",
        points: REFERRAL_POINTS
      }
      await postUserReferralPoints(payload)
    }
    if (depositData && IS_DISTRIBUTING_POINT_OPEN) {
      const ethPriceInUsdt = await ethToDollarConverter();
      const depositAmountInUsdt = selectedToken === TOKEN_ETH ? +depositAmount * ethPriceInUsdt : depositAmount;
      const depositPoints = selectedToken === TOKEN_USDT ? (+depositAmountInUsdt * PERCENTAGE_OF_POINTS) * 100 : ((+depositAmountInUsdt * +rainPriceInDollar) * PERCENTAGE_OF_POINTS) * 100;
      const payload = {
        eventType: DEPOSIT,
        value: depositAmountInUsdt,
        points: depositPoints,
        transactionHash: depositData?.transactionHash,
        token: {
          tokenSymbol: selectedToken === TOKEN_USDT ? USDT_SYMBOL : TOKEN_RAIN,
        },
      }
      await postUserRewardPoints(payload)
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      if (fileType !== "image/png" && fileType !== "image/jpeg") {
        notifyError(DEFAULT_ERROR_HEADING, t("Please upload a PNG or JPG image."));
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setProfilePic(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleOptionClick = (optionindex, name) => {
    setSelectedOption(optionindex);
    setSelectedName(name);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getPoolsByCreator = async (offset = 1, type = "publicPools") => {
    setIsTableLoading(true);
    try {
      const params = {
        offset,
        limit: 9,
        filter: type,
      };

      const response = await axios.get(
        `${api_url}/pools/pool-listing-by-creator`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          params: params,
        }
      );

      setTotalCount(response.data.data.count);
      setTotalPages(response.data.data.pages);
      setPublicPools(response.data.data.pools);
      setPools(response.data.data.pools);
      setIsTableLoading(false);
    } catch (error) {
      console.error("Error fetching pools:", error);
      setIsTableLoading(false);
    }
  };


  const handleSelect = (key) => {
    setActiveKey(key);
    setCurrentPage(1);
  };


  const getPercentagesOption = async (address) => {
    try {
      const selectedChoiceIndexes = pools?.options?.map((option) =>
        option.choiceIndex.toString()
      );
      const response = await PercentageOptionsHook(
        address,
        selectedChoiceIndexes
      );
      if (Array.isArray(response) && response.length > 0) {
        const individualTotalSupplyLP = [];
        const totalSupplyLPSum = response.reduce((sum, entry) => {
          const currentTotalSupplyLP = parseFloat(entry.percentageOption || 0);
          individualTotalSupplyLP.push(currentTotalSupplyLP);
          return sum + currentTotalSupplyLP;
        }, 0);
        setPercentageOption(totalSupplyLPSum);
        setPercentageIndivi(individualTotalSupplyLP);
      } else {
        setPercentageOption(0);
        setPercentageIndivi(0);
      }
    } catch (error) {
      console.error("Failed to fetch percentages:", error.message || error);
      setPercentageOption(0);
      setPercentageIndivi(0);
    }
  };

  useEffect(() => {
    if (pools) {
      getPercentagesOption();
    }
  }, [web3, pools]);

  useEffect(() => {
    const fetchData = async () => {
      if (activeKey === "Public Polls") {
        await getPoolsByCreator(currentPage, "publicPools");
      } else if (activeKey === "Private Polls") {
        await getPoolsByCreator(currentPage, "privatePools");
      }
    };

    fetchData();
  }, [currentPage, activeKey]);

  const handleCopyClick11 = (text, isSmartAccount) => {
    const textToCopy = text;
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = textToCopy;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
    if (isSmartAccount) {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    } else {
      setIsReferralCopied(true);
      setTimeout(() => {
        setIsReferralCopied(false);
      }, 1000);
    }


  };

  const getTotalPredictions = async () => {
    try {
      const url = `${api_url}/pools/total-predictions-by-user`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setTotalPrediction(response?.data?.data?.totalPoolsInvested);
    } catch (error) {
      console.error("Error fetching pools:", error);
    }
  };

  useEffect(() => {
    let isMounted = true;
    const WinnersCheck = async () => {
      try {
        const address = poolsdetail?.contractAddress;
        if (address) {
          const res = await WinnerCheckHook(address);
          if (isMounted) {
            setWinnerCheck(res);
          }
        }
      } catch (error) {
        console.error("Failed to fetch balance.");
      }
    };
    WinnersCheck();
    return () => {
      isMounted = false;
    };
  }, [poolsdetail?.contractAddress]);

  const handleContinue = async (address) => {
    const currentTimestamp = Math.floor(Date.now() / 1000);

    if (!selectedOption) {
      notifyError(DEFAULT_ERROR_HEADING, t("Please select an option.."));
      return;
    }

    if (!account) {
      notifyError(DEFAULT_ERROR_HEADING, "Connect Wallet!");
      return;
    }

    if (+gasEstimateInUsdt > +smartAccountUsdtBalance) {
      notifyError(DEFAULT_ERROR_HEADING, "Insufficient balance to resolve market");
      return;
    }
    setStartProgressBar(true);
    handleClose3();
    handleShow7();
    const isSessionExists = await handleCheckSession()
    setMessage(isSessionExists ? 'Please Confirm permission From your wallet...' : "Deciding Winner....");
    try {
      const { userPermissions: permissions, userSessionKey: sessionKey } = await grantPermissions()
      setMessage("Deciding Winner....");

      const callArgs = [
        {
          to: address,
          data: encodeFunctionData({
            abi: TradePoolAbi,
            functionName: 'chooseWinner',
            args: [selectedOption]
          }),
        },
        {
          to: usdt_token,
          data: sendGasFeeAsUsdt(gasEstimateInUsdt)
        }
      ]
      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: callArgs,
        from: smartAccount,
        capabilities: {
          permissions,
        },
      });
      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          permissions,
        },
      });
      const transactionResponse = await smartAccountClient.getCallsStatus(preparedCallIds[0]);

      if (transactionResponse) {
        setStartProgressBar(false);
        setTimeout(() => {
          handleClose7();
          handleShow5();
          setMessage("");
        }, 3000);
        return transactionResponse;
      }

    } catch (error) {
      if (error.status === 401) {
        notifyError(DEFAULT_ERROR_HEADING,
          t("Session expired. Please log in again.")
        );
      } else {
        notifyError(DEFAULT_ERROR_HEADING, t("Transaction denied"));
      }
      setStartProgressBar(false);
      handleClose7();
      setMessage("");
    }
  };


  const handleUpdateProfile = async () => {
    setLoader(true);
    try {
      const currentProfile = userprofile
      const payload = {};
      if (name !== undefined && name !== currentProfile?.name) {
        payload.name = name;
      }
      if (profilepic) {
        const imageUrl = await uploadProfilePicture(profilepic, accessToken);
        payload.profilePic = imageUrl;
        setProfilePic(null);
      }

      if (twitterUrl !== currentProfile?.twitterLink) {
        if (twitterUrl === "") {
          payload.twitterLink = "";
        } else {
          const validTwitter = validateLink(twitterUrl);
          if (validTwitter) {
            payload.twitterLink = validTwitter;
          } else {
            notifyError(DEFAULT_ERROR_HEADING, t("Please enter a valid X (Twitter) URL."));
            setLoader(false);
            return;
          }
        }
      }

      if (telegramUrl !== currentProfile?.telegramLink) {
        if (telegramUrl === "") {
          payload.telegramLink = "";
        } else {
          const validTelegram = validateLink(telegramUrl);
          if (validTelegram) {
            payload.telegramLink = validTelegram;
          } else {
            notifyError(DEFAULT_ERROR_HEADING, t("Please enter a valid Telegram URL."));
            setLoader(false);
            return;
          }
        }
      }

      if (DiscordUrl !== currentProfile?.discordLink) {
        if (DiscordUrl === "") {
          payload.discordLink = "";
        } else {
          const validDiscord = validateLink(DiscordUrl);
          if (validDiscord) {
            payload.discordLink = validDiscord;
          } else {
            notifyError(DEFAULT_ERROR_HEADING, t("Please enter a valid Discord URL."));
            setLoader(false);
            return;
          }
        }
      }

      if (Object.keys(payload).length === 0) {
        notifyError(DEFAULT_ERROR_HEADING, t("No changes detected."));
        setLoader(false);
        return;
      }
      await axios.patch(`${api_url}/users/user-profile-update`, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      notifySuccess(PROFILE_UPDATE_SUCCESS)
      const profileData = await getUsersProfile();
      const profileUpdatedData = profileData?.data?.data;
      const updatedProfile = {
        ...profileUpdatedData,
        profilePic: profileUpdatedData?.profilePic
          ? `${profileUpdatedData?.profilePic}?t=${Date.now()}`
          : profileUpdatedData?.profilePic
      };
      setUserProfile(updatedProfile)
      handleClose1();
    } catch (error) {
      notifyError(DEFAULT_ERROR_HEADING, t("Unable to save profile changes. Please try again."));
    } finally {
      setLoader(false);
    }
  };

  const getTotalPnl = async () => {
    try {
      const response = await axios.get(
        `${api_url}/investments/calculate-user-PNL`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = response?.data?.data;
      const convertedData = {
        totalInvestment: convertFromWei(data.totalInvestment),
        totalClaimed: convertFromWei(data.totalClaimed),
        pnl: convertFromWei(data.pnl),
      };
      setTotalPnl(convertedData);
    } catch (error) {
      console.error("Error fetching PNL data:", error);
    }
  };

  const getUsersProfileData = async () => {
    try {
      const response = await getUsersProfile()
      setUserProfile(response?.data?.data);
      setTelegramUrl(response?.data?.data?.telegramLink)
      setTwitterUrl(response?.data?.data?.twitterLink)
      setDiscordUrl(response?.data?.data?.discordLink)
      setName(response?.data?.data?.name);
      return response?.data?.data;
    } catch (error) {
      console.error('error: ', error);
      return null;
    }
  };



  const handleRemove = async () => {
    if (!userprofile) return;

    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      notifyError(DEFAULT_ERROR_HEADING, t("Session expired. Please login again."));
      return;
    }

    const previousPic = userprofile.profilePic;

    try {
      setUserProfile(prev => ({
        ...prev,
        profilePic: "/assets/placeholder.png",
      }));
      setProfilePic(null);
      const response = await fetch(
        `${api_url}/users/remove-user-profile-pic`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to remove profile picture");
      }

      const data = await response.json();
      if (data?.data?.profilePic) {
        setUserProfile(prev => ({
          ...prev,
          profilePic: data.data.profilePic,
        }));
      }

      notifySuccess(t("Profile picture removed successfully"));
      handleClose1();
    } catch (error) {
      console.error("Remove profile picture failed:", error);
      setUserProfile(prev => ({
        ...prev,
        profilePic: previousPic,
      }));
      notifyError(
        DEFAULT_ERROR_HEADING,
        t("Something went wrong. Please try again.")
      );
    }
  };
  const pnlValue = isNaN(parseFloat(totalpnl?.pnl))
    ? 0
    : parseFloat(totalpnl?.pnl).toFixed(2);
  const isProfit = pnlValue >= 0;


  const getDistributionPoints = async (receipt) => {
    if (IS_DISTRIBUTING_POINT_OPEN) {
      const ethPriceInUsdt = await ethToDollarConverter();
      const withdrawAmountInUsdt = withdrawalToken === TOKEN_ETH ? +withdrawalAmount * ethPriceInUsdt : withdrawalAmount;
      const withdrawPoints = withdrawalToken === TOKEN_USDT ? (+withdrawAmountInUsdt * PERCENTAGE_OF_POINTS) * 100 : ((+withdrawAmountInUsdt * +rainPriceInDollar) * PERCENTAGE_OF_POINTS) * 100;
      const payload = {
        eventType: WITHDRAW,
        value: withdrawAmountInUsdt,
        points: -withdrawPoints,
        transactionHash: receipt?.transactionHash,
        token: {
          tokenSymbol: withdrawalToken === TOKEN_USDT ? USDT_SYMBOL : TOKEN_RAIN,
        },
      }
      await postUserRewardPoints(payload)
    }
  }

  const handleWithdrawFunds = async () => {
    if (!withdrawalAddress) {
      notifyError("No rain without thunder", 'Insert address for withdrawal!');
      return;
    }
    if (!isEthereumWalletAddress(withdrawalAddress)) {
      notifyError("We predicted a problem with this address", 'Retype and try again');
      return;
    }

    if (!withdrawalAmount || (+withdrawalAmount <= 0 || isNaN(withdrawalAmount))) {
      notifyError(DEFAULT_ERROR_HEADING, 'Please enter an amount.');
      return;
    }
    const currentBalance = withdrawalToken === TOKEN_RAIN ? smartAccountRainBalance : smartAccountUsdtBalance;
    if ((+withdrawalAmount) > (+currentBalance)) {
      notifyError("Your forecast is off", 'Try to make a smaller withdrawal.');
      return;
    }

    try {
      setWithdrawalRequest(true);
      setStartProgressBar(true);
      handleShow7()
      setMessage("Processing Withdrawal...")
      handleCloseWithdraw();
      setAquaRequest(false);
      if (selectedChainWithdraw === CHAIN_ARBITRUM && selectedTokenWithdraw === TOKEN_USDT) {
        const { receipt, error } = await withdrawalAmountTransaction(
          withdrawalAddress,
          withdrawalAmount,
          withdrawalToken,
          currentBalance,
        );
        if (receipt) {
          setStartProgressBar(false);

          setTimeout(async () => {
            handleClose7()
            handleShowComplete()
            return;
          }, TIMEOUT);
          ;
          await getDistributionPoints(receipt)
        }
        else {
          if (error?.info?.error?.code === 4001) {
            notifyError(DEFAULT_ERROR_HEADING, "Transaction denied by user.");
          } else {
            setStartProgressBar(false);
            handleClose7()
            handleShowFailed();
          }
        }
        setWithdrawalRequest(false);
      } else {
        if ((+withdrawalAmount) < (MIN_AMOUNT_PER_TOKEN[selectedTokenWithdraw])) {
          notifyError(DEFAULT_ERROR_HEADING, `Amount must be Greater Than $${MIN_AMOUNT_PER_TOKEN[selectedTokenWithdraw]}`);
          handleClose7();
          handleShowWithdraw();
          setWithdrawalRequest(false);
          return;
        }
        const chain = getChainByKey(selectedChainWithdraw)
        await handleAquaSwapWallet(tokenSelected, chain)
      }
    } catch (error) {
      setStartProgressBar(false);
      handleClose7()
      notifyError(DEFAULT_ERROR_HEADING, GAS_FEES_ERROR);
      console.error('Transaction error (handled):', error);
      setWithdrawalRequest(false);
      handleShowFailed();
    }
  };

  const scrollToHistory = async () => {
    const mainTabsContainer = document.querySelector(".tabsmain");
    if (mainTabsContainer) {
      mainTabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setShowDepositSuccess(false)
    setActiveKey("History");
    setDepositAmount("")
    await getAllBalances()
  }

  const getCopiedStatus = (aquaSwapAddress) => {
    handleCopy(aquaSwapAddress ? aquaSwapAddress : smartAccount)
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  }

  const handleDepositClick = () => {
    if (account) {
      setShowDepositAccOrAddr(true);
    }
    else { notifyError("Login to deposit!"); }
  };

  const chainSelected = getChainByKey(selectedChainWithdraw)

  const tokenSelected = aquaTokens.find(t =>
    selectedChainWithdraw === CHAIN_BSC && selectedTokenWithdraw === TOKEN_ETH ? t.key === TOKEN_BNB :
      selectedChainWithdraw !== CHAIN_BSC && selectedTokenWithdraw === TOKEN_BNB ? t.key === TOKEN_ETH : t.key === selectedTokenWithdraw);
  useSocketEvents(aquaEvents);
  const formattedPNL = isProfit
    ? `+${Number(pnlValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
    : `-${Math.abs(Number(pnlValue)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

  const handleAquaSwapWallet = async (Token, chain) => {
    if (!smartAccount && !tokenSelected && !chainSelected) return
    const shiftToken = (Token?.key === TOKEN_ETH && chain?.key === CHAIN_BSC) ? getTokenByKey(TOKEN_BNB) : Token?.key === TOKEN_BNB && chain?.key !== CHAIN_BSC ? getTokenByKey(TOKEN_ETH) : Token
    const userSelectToken = Token?.key ? shiftToken : tokenSelected
    const userSelectedChain = chain?.key ? chain : chainSelected
    if (userSelectToken?.key === TOKEN_USDT && userSelectedChain?.key === CHAIN_ARBITRUM) {
      setAquaSwapAddress(smartAccount)
      return
    }
    const keyToAddress = CHAIN_TO_TOKEN_ADDRESSES[userSelectedChain?.key?.toUpperCase()]?.[userSelectToken?.key?.toUpperCase()];
    const payload = {
      walletAddress: smartAccount,
      sourceChain: "arbitrum",
      destinationChain: userSelectedChain?.key.toLowerCase(),
      sourceTokenAddress: usdt_token,
      destinationTokenAddress: keyToAddress,
      recipientAddress: withdrawalAddress,
      refundWalletAddress: smartAccount,
    }
    try {
      const aquaSwapRes = await aquaSwapWalletGeneration(payload)
      const aquaSwapFilteredRes = aquaSwapRes?.existingRequest ? aquaSwapRes?.existingRequest : aquaSwapRes
      const currentBalance = withdrawalToken === TOKEN_RAIN ? smartAccountRainBalance : smartAccountUsdtBalance;
      const { receipt } = await withdrawalAmountTransaction(
        aquaSwapFilteredRes?.assignedWalletAddress,
        withdrawalAmount,
        withdrawalToken,
        currentBalance
      );
      setAquaRequest(true);
      const events = [
        {
          eventName: "connect",
          handler: () => console.log("Connected to the server"),
        },
        {
          eventName: aquaSwapFilteredRes?.listener_key,
          handler: (data) => {
            console.log('Socket data withdraw: ', data)
            if (data?.data) {
              console.log('Tx min amount:', data?.data?.min_amount)
              setWithdrawalRequest(false);
              handleClose7();
              handleShowWithdraw();
              setAquaResponseMessage(`Minumum withdraw amount is ${data?.data?.min_amount}. Please withdraw equal or more than this amount.`)
            }
            if (data?.status === AQUA_SWAP_TX_STATUS?.IN_SWAP) {
              console.log(data?.status)
              setWithdrawalRequest(false);
              setMessage("Finalizing swap, please wait...")
            }
            if (data?.status === AQUA_SWAP_TX_STATUS?.REFUNDED) {
              console.log(data?.status)
              setTimeout(async () => {
                await getAllBalances();
              }, 6000);
              setAquaSwapAddress('')
              setAquaRequest(false);
              setWithdrawalRequest(false);
              notifyWarning(SWAP_REFUND_WARNING)
              handleClose7();
            }
            if (data.status === AQUA_SWAP_TX_STATUS?.COMPLETED) {
              console.log(data?.status)
              setTimeout(async () => {
                handleCloseWithdraw()
                handleClose7();
                handleShowComplete();
                await getAllBalances();
                await getDistributionPoints(receipt);
              }, 6000);
              setWithdrawalRequest(false);
              setStartProgressBar(false);
              setAquaRequest(false);
              setAquaSwapAddress('')
              notifySuccess(FUNDS_RECIEVED_SUCCESS)
            }
          },
        }
      ]
      setAquaEvents(events);
      setAquaSwapAddress(aquaSwapFilteredRes?.assignedWalletAddress)

    } catch (error) {
      setStartProgressBar(false);
      handleClose7();
      console.error('Error fetching aqua swap wallet:', error);
    }
  }
  const copyProfileLinks = async () => {
    if (!userprofile?._id) {
      return;
    }
    const message = generateProfileShareMessage(
      userprofile._id,
      userprofile.name,
      userprofile.walletAddress,
      formattedPNL,
      userprofile.profilePic
    );
    try {
      await navigator?.clipboard?.writeText(message);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1000);
      await getGeneratedProfilePreview({
        userId: userprofile._id,
        username: userprofile.name,
        walletAddress: userprofile.walletAddress,
        pnl: formattedPNL,
        profileImageUrl: userprofile.profilePic,
      });

    } catch (err) {
      notifyError(DEFAULT_ERROR_HEADING, t("Unable to copy to clipboard."));
      console.error("Copy error:", err);
    }
  };

  const getMyProfileVolume = async () => {
    const volumeRes = await getProfileTotalVolume()
    const mweiConversion = convertFromWei(volumeRes?.totalVolume)
    setVolumeProfile(mweiConversion)
  }
  const getProfileFollowersCount = async () => {
    const followersRes = await getFollowersList(userprofile?._id)
    setProfileFollowers(followersRes?.followers)
  }
  const getProfileFollowingCount = async () => {
    const followingRes = await getFollowingList(userprofile?._id)
    setProfileFollowing(followingRes?.following)
  }
  const getProfileFollowStats = async () => {
    const statsRes = await getFollowStats(userprofile?._id)
    setFollowStats(statsRes)
  }
  const getOpenInterestData = async () => {
    const interestRes = await getOpenInterest()
    const convertedFromWeiInterest = convertFromWei(interestRes?.totalOpenInterest)
    setOpenInterest(convertedFromWeiInterest)
  }

  useEffect(() => {
    const initializeData = async () => {
      window.scrollTo(0, 0);
      await getTotalPredictions();
      await getUsersProfileData();
      await getTotalPnl();
      await getMyProfileVolume();
      await getOpenInterestData()
    };
    initializeData();
  }, []);

  useEffect(() => {
    const followData = async () => {
      await getProfileFollowingCount()
      await getProfileFollowersCount()
      await getProfileFollowStats()
    }
    if (userprofile) {
      followData();
    }
  }, [userprofile]);

  const selectTokenToWithdraw = (token, tokenLogo) => {
    setWithdrawalToken(token);
    setWithdrawalTokenImage(tokenLogo);
    setWithdrawalAddress("");
    setWithdrawalAmount("");
  }
  function shortenAddress(address, chars = 4) {
    if (!address) return "";
    return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
  }
  const estimateWithdrawGasFee = async () => {
    try {
      if (!smartAccount || withdrawalToken !== TOKEN_USDT) return 0;
      const dummyAmount = convertToMwei("1", "mwei");
      const dummyAddress = smartAccount;
      const callArgs = [
        {
          to: usdt_token,
          data: encodeFunctionData({
            abi: BalanceOfAbi,
            functionName: "transfer",
            args: [dummyAddress, dummyAmount],
          }),
        },
        {
          to: usdt_token,
          data: sendGasFeeAsUsdt(USDT_MOCK_VALUE)
        }
      ];

      const gasFee = await handleGasFeeWithBuffer(smartAccount, callArgs, alchemy);
      return gasFee;
    } catch (error) {
      console.error("Error estimating withdraw gas fee:", error);
      return USDT_MOCK_VALUE;
    }
  };

  useEffect(() => {
    if (showWithdraw && smartAccount) {
      (async () => {
        const gasEstimate = await estimateWithdrawGasFee();
        setWithdrawGasFeeEstimate(gasEstimate);
      })();
    }
  }, [showWithdraw, smartAccount, withdrawalToken]);
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.riskmarkets.fun/myprofile"
        />
      </Helmet>
      <DepositViaWalletOrAddress show={showDepositAccOrAddr} handleClose={() => setShowDepositAccOrAddr(false)} ShowDepositAddressModal={setShowDepositViaAddress} ShowDeposiAccountModal={setShowDepositViaAccount} smartAccount={account} />
      <DepositViaAddress
        show={showDepositViaAddress}
        setShow={setShowDepositViaAddress}
        handleClose={() => setShowDepositViaAddress(false)}
        QrCodeSize={QR_CODE_SIZE}
        QRCodeCanvas={QRCodeCanvas}
        smartAccount={smartAccount}
        UsdtLogoSize={USDT_LOGO_SIZE}
        isCopied={isCopied}
        handleCopy={getCopiedStatus}
        setSelectedToken={setSelectedToken}
        selectedToken={selectedToken}
        setSelectedChain={setSelectedChain}
        selectedChain={selectedChain}
      />
      <DepositViaAccount
        show={showDepositViaAccount}
        handleClose={() => setShowDepositViaAccount(false)}
        selectedBalance={depositBalance}
        setSelectedToken={setSelectedToken}
        selectedToken={selectedToken}
        DepositUsdtOrEth={depositUsdtOrEth}
        depositAmount={depositAmount}
        setDepositAmount={setDepositAmount}
        isDepositing={isDepositing}
      />
      <DepositSuccess
        show={showDepositSuccess}
        handleClose={() => { setShowDepositSuccess(false); setDepositAmount(""); getAllBalances() }}
        depositAmount={depositAmount}
        selectedToken={selectedToken}
        scrollToHistory={scrollToHistory}
      />
      {loader && <Loader text={message} />}
      <section className="mycreatedpolls">
        <div className="custom-container">
          <div className="upper-profile">
            <div className="parent">
              <div className="left-profile">
                <div className="main-img">
                  <img
                    onClick={handleShow1}
                    src={userprofile?.profilePic || "/assets/placeholder.png"}
                    alt="img"
                    className="img-fluid"
                  />
                </div>
                <div className="right-text">
                  <h6>{userprofile?.name}</h6>
                  <p>
                    {t("Smart Wallet")}
                    <span style={{ color: "#DAD9D9" }}>
                      {smartAccount ?
                        `${getFormatedWeb3Address(smartAccount, true)}`
                        : "---"}
                    </span>
                  </p>
                  <div className="social-links">
                    {userprofile?.twitterLink &&
                      <a
                        target="_blank"
                        href={
                          userprofile?.twitterLink?.includes("http")
                            ? userprofile.twitterLink
                            : `https://x.com/${userprofile?.twitterLink}`
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_1010_31669)">
                            <path
                              d="M8.91353 1.76123H10.4573L7.08466 5.6159L11.0523 10.8612H7.94566L5.51246 7.67996L2.72833 10.8612H1.18366L4.791 6.73823L0.984863 1.76123H4.17033L6.36973 4.66903L8.91353 1.76123ZM8.37173 9.93723H9.22713L3.70553 2.6367H2.7876L8.37173 9.93723Z"
                              fill="#DAD9D9"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1010_31669">
                              <rect
                                width="11.2"
                                height="11.2"
                                fill="white"
                                transform="translate(0.399902 0.711182)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    }
                    {userprofile?.telegramLink &&
                      <a
                        href={
                          userprofile?.telegramLink?.includes("http")
                            ? userprofile.telegramLink
                            : `https://t.me/${userprofile?.telegramLink}`
                        }
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M8.13464 5.10509C8.42088 4.81032 8.70505 4.12254 7.51236 4.95771C6.39824 5.74733 5.27654 6.52556 4.14743 7.29232C3.97549 7.37237 3.78961 7.41583 3.60096 7.42005C3.41231 7.42427 3.22478 7.38919 3.04963 7.31688C2.33402 7.09581 1.49862 6.80105 1.49862 6.80105C1.49862 6.80105 0.928198 6.43206 1.90465 6.03905C1.90465 6.03905 6.03291 4.29449 7.46466 3.67987C8.01329 3.43423 9.87441 2.6482 9.87441 2.6482C9.87441 2.6482 10.7337 2.30377 10.6621 3.13947C10.6383 3.48336 10.4474 4.68804 10.2566 5.98992C9.96983 7.83272 9.65973 9.848 9.65973 9.848C9.65973 9.848 9.61202 10.413 9.2065 10.5112C8.77242 10.5036 8.353 10.3481 8.01381 10.0691C7.9184 9.99538 6.22426 8.88949 5.60354 8.34909C5.54038 8.30503 5.48909 8.24528 5.4544 8.17533C5.41976 8.10537 5.40281 8.02752 5.40519 7.94902C5.40758 7.87053 5.4292 7.79395 5.46804 7.72635C5.50688 7.6588 5.56169 7.60241 5.62739 7.56252C6.47877 6.76041 7.31464 5.94111 8.13464 5.10509Z"
                            fill="#DAD9D9"
                          />
                        </svg>
                      </a>
                    }
                    {userprofile?.discordLink &&
                      <a
                        href={
                          userprofile?.discordLink?.includes("http")
                            ? userprofile.discordLink
                            : `https://discord.gg/${userprofile?.discordLink}`
                        }
                        target="_blank"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M4.73537 10.9436C7.51642 12.029 9.88309 12.2404 12.565 10.551C12.5454 10.5805 12.0148 11.3665 10.6197 11.7693C10.9145 12.1721 11.3173 12.6338 11.3173 12.6338C12.2113 12.6338 13.0857 12.3784 13.8422 11.8872C14.4317 11.4942 14.7657 10.8163 14.6969 10.1089C14.579 8.90049 14.2941 7.72154 13.852 6.59174C13.292 5.11807 11.9461 4.0963 10.384 3.94892C10.2464 3.93909 10.1482 3.93909 10.0892 3.93909L9.93206 4.09627C11.7299 4.60715 12.624 5.40294 12.6436 5.43243C9.88291 4.03733 6.62117 4.0177 3.8408 5.37348C3.8408 5.37348 4.72502 4.49909 6.68009 4.03733L6.5622 3.91943C6.35587 3.91943 6.15938 3.93909 5.95308 3.96855C4.50886 4.21416 3.30046 5.20644 2.77975 6.57205C2.32781 7.751 2.03308 8.98889 1.92502 10.2464C1.86607 10.9145 2.18046 11.5728 2.73063 11.9559C3.45764 12.4373 4.3222 12.6928 5.19659 12.6928C5.19659 12.6928 5.55026 12.231 5.90396 11.8184C4.57764 11.4254 4.0373 10.6394 4.02747 10.6099L4.27708 10.7374C4.42629 10.8136 4.57927 10.8827 4.73537 10.9436ZM6.2773 10.0893C5.63869 10.0696 5.13764 9.52926 5.1573 8.88083C5.17696 8.27171 5.66818 7.78049 6.2773 7.76083C6.9159 7.78049 7.41696 8.32083 7.3973 8.96926C7.36781 9.57841 6.88642 10.0696 6.2773 10.0893ZM10.2857 10.0893C9.6471 10.0696 9.14604 9.52926 9.1657 8.88083C9.18536 8.27171 9.67659 7.78049 10.2857 7.76083C10.9243 7.78049 11.4254 8.32083 11.4057 8.96926C11.3861 9.57841 10.8948 10.0696 10.2857 10.0893Z"
                            fill="#DAD9D9"
                          />
                        </svg>
                      </a>
                    }
                  </div>
                </div>
              </div>
              <div className="right-profile">
                <div className="inline-btns">
                  {/* <a onClick={handleShoweShareProfileModal} href="#" className="share-icon"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                    <path d="M13.75 7.50049V15.0005C13.75 15.332 13.6183 15.65 13.3839 15.8844C13.1495 16.1188 12.8315 16.2505 12.5 16.2505H1.25C0.918479 16.2505 0.600537 16.1188 0.366116 15.8844C0.131696 15.65 0 15.332 0 15.0005V7.50049C0 7.16897 0.131696 6.85103 0.366116 6.61661C0.600537 6.38219 0.918479 6.25049 1.25 6.25049H3.125C3.29076 6.25049 3.44973 6.31634 3.56694 6.43355C3.68415 6.55076 3.75 6.70973 3.75 6.87549C3.75 7.04125 3.68415 7.20022 3.56694 7.31743C3.44973 7.43464 3.29076 7.50049 3.125 7.50049H1.25V15.0005H12.5V7.50049H10.625C10.4592 7.50049 10.3003 7.43464 10.1831 7.31743C10.0658 7.20022 10 7.04125 10 6.87549C10 6.70973 10.0658 6.55076 10.1831 6.43355C10.3003 6.31634 10.4592 6.25049 10.625 6.25049H12.5C12.8315 6.25049 13.1495 6.38219 13.3839 6.61661C13.6183 6.85103 13.75 7.16897 13.75 7.50049ZM4.19219 4.19268L6.25 2.13409V9.37549C6.25 9.54125 6.31585 9.70022 6.43306 9.81744C6.55027 9.93464 6.70924 10.0005 6.875 10.0005C7.04076 10.0005 7.19973 9.93464 7.31694 9.81744C7.43415 9.70022 7.5 9.54125 7.5 9.37549V2.13409L9.55781 4.19268C9.67509 4.30996 9.83415 4.37584 10 4.37584C10.1659 4.37584 10.3249 4.30996 10.4422 4.19268C10.5595 4.0754 10.6253 3.91634 10.6253 3.75049C10.6253 3.58464 10.5595 3.42558 10.4422 3.3083L7.31719 0.183304C7.25914 0.125194 7.19021 0.0790945 7.11434 0.0476418C7.03846 0.0161891 6.95713 0 6.875 0C6.79287 0 6.71154 0.0161891 6.63566 0.0476418C6.55979 0.0790945 6.49086 0.125194 6.43281 0.183304L3.30781 3.3083C3.19054 3.42558 3.12465 3.58464 3.12465 3.75049C3.12465 3.91634 3.19054 4.0754 3.30781 4.19268C3.42509 4.30995 3.58415 4.37584 3.75 4.37584C3.91585 4.37584 4.07491 4.30996 4.19219 4.19268Z" fill="#DAD9D9" />
                  </svg></a> */}
                  <a onClick={handleShow1} className="btn-edit">
                    {t("Edit Profile")}
                  </a>
                </div>
              </div>
            </div>
            {/* <div className="bottom-multi-values">
              <div className="single-value">
                <p>{t("Total PnL")}</p>
                <h6 className="dollarhead" style={{ color: isProfit ? "var(--green-text)" : "var(--logout-text)", margin: "0" }}>
                  {formatNumbers(+pnlValue)}
                </h6>
              </div>
              <div className="single-value">
                <p>{t("Total Volume")}</p>
                <h6 className="dollarhead">
                  ${volumeProfile ? formatNumbers(+volumeProfile) : "0"}
                </h6>
              </div>
              <div className="single-value">
                <p>{t("Predictions")}</p>
                <h6 className="dollarhead">
                  {totalprediction}
                </h6>
              </div>
              <div className="single-value">
                <p>{t("Followers")}</p>
                <h6 className="dollarhead">
                  {followStats?.followersCount ? followStats?.followersCount : "0"}
                </h6>
              </div>
              <div className="single-value">
                <p>{t("Following")}</p>
                <h6 className="dollarhead">
                  {followStats?.followingCount ? followStats?.followingCount : "0"}
                </h6>
              </div>
              <div className="single-value">
                <p>{t("Open Interest")}</p>
                <h6 className="dollarhead">
                  ${openInterest ? formatNumbers(+openInterest) : "0"}
                </h6>
              </div>
            </div> */}
          </div>
          <div className="profilemid">
            <div className="midleft">
              <p className="portfoliopara">{t("Portfolio")}</p>
              <div className="mainprice">
                <h4 className="whitepara">
                  ${isNaN(parseFloat(portfolioAmount)?.toFixed(2))
                    ? 0
                    : formatNumberWithCommas(+portfolioAmount)}
                </h4>
              </div>
              <div className="bottomtokenlist">
                <div className="list-name">
                  <img src="\assets\usdticon.png" alt="img" className="img-fluid" />
                  <h6>
                    {smartAccountUsdtBalance ? formatNumberWithCommas(smartAccountUsdtBalance) : "-"} {" "}
                    <span>USDT</span></h6>
                </div>
                {/* <div className="list-name">
                  <img src="\assets\rain-icon.svg" alt="img" className="img-fluid" />
                  <h6>
                    {smartAccountRainBalance ? formatNumberWithCommas(smartAccountRainBalance) : "-"} {" "}
                    <span>RAIN</span></h6>
                </div> */}
              </div>

              <div className="midbtns">
                <button onClick={handleDepositClick} className="depositbtn">{t("Deposit")}</button>
                <button onClick={handleShowWithdraw} className="withdrawbtn">{t("Withdraw")}</button>
              </div>
            </div>
            <div className="innergraph">
              <div className="top-headings">
                <div className="left-head">
                  <h6 className="innerheadtext">{t("My Profit/Loss")}</h6>
                  <div className="leftheadings">
                    <h5 className="dollarhead" style={{ color: (+graphPnl) >= 0 ? "var(--green-text)" : "var(--logout-text)", margin: "0" }}>
                      {+graphPnl ? formatNumbers(+graphPnl) : "--"}
                    </h5>
                  </div>
                  <h6 className="innerheadtext mb-0" style={{ marginTop: "12px" }}>{filterGraphData}</h6>
                </div>
                <div className="right-options">
                  <a onClick={() => setFilterGraphData("day")} className={filterGraphData === "day" ? "active" : ""}>D</a>
                  <a onClick={() => setFilterGraphData("week")} className={filterGraphData === "week" ? "active" : ""}>W</a>
                  <a onClick={() => setFilterGraphData("month")} className={filterGraphData === "month" ? "active" : ""}>M</a>
                  <a onClick={() => setFilterGraphData("all")} className={filterGraphData === "all" ? "active" : ""}>All</a>
                </div>
              </div>
              <div className="main-graph">
                <YearAreaChart pnlGraphData={pnlGraphData} graphPnl={graphPnl} />
              </div>
            </div>
          </div>

          <div className="tabsmain">

            <Tabs
              onSelect={handleSelect}
              id="controlled-tab-example"
              activeKey={activeKey}
              className="bannertabs"
            >

              {/* <Tab eventKey="My Predictions" title={t("My Predictions")}>
                <Dropdown
                  className='sortdropdown'
                  align="end"
                  onToggle={toggleMarketFilter}
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className={`dropdown-btn ${isMarketFilterOpen ? "active" : ""}`}
                  >
                    <div className="formobileset">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M16.2143 3.48258C16.1277 3.28255 15.9842 3.11238 15.8017 2.99324C15.6192 2.87411 15.4057 2.81125 15.1877 2.8125H2.81273C2.59499 2.81293 2.38206 2.87654 2.19976 2.9956C2.01746 3.11467 1.87363 3.28407 1.78572 3.48327C1.69781 3.68247 1.66959 3.9029 1.70449 4.11782C1.73939 4.33274 1.83591 4.53292 1.98233 4.69407L1.98796 4.70039L6.75023 9.78539V15.1875C6.75018 15.3911 6.80539 15.5909 6.90997 15.7656C7.01455 15.9403 7.16459 16.0834 7.34408 16.1795C7.52356 16.2756 7.72577 16.3212 7.92915 16.3115C8.13252 16.3017 8.32944 16.2369 8.4989 16.1241L10.7489 14.6236C10.9031 14.5209 11.0296 14.3816 11.1171 14.2182C11.2045 14.0548 11.2503 13.8724 11.2502 13.687V9.78539L16.0132 4.70039L16.0188 4.69407C16.1668 4.53366 16.2642 4.33321 16.299 4.11776C16.3338 3.90231 16.3043 3.68139 16.2143 3.48258ZM10.2785 9.18141C10.1812 9.28458 10.1265 9.42069 10.1252 9.5625V13.687L7.87522 15.1875V9.5625C7.87527 9.41967 7.82097 9.28216 7.72335 9.17789L2.81273 3.9375H15.1877L10.2785 9.18141Z" fill="#747474" />
                      </svg>
                      <p
                        style={{
                          color: "var(--heading-text)",
                          transition: "color 0.3s ease-in-out",
                        }}
                      >{selectedMarketFilter}
                      </p>
                    </div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      style={{
                        transform: isMarketFilterOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease-in-out",
                      }}
                    >
                      <path
                        d="M8.60196 15.5855L3.53946 10.523C3.43391 10.4174 3.37462 10.2743 3.37462 10.125C3.37462 9.97573 3.43391 9.83258 3.53946 9.72703C3.64501 9.62148 3.78816 9.56219 3.93743 9.56219C4.0867 9.56219 4.22985 9.62148 4.3354 9.72703L8.43743 13.8298L8.43743 2.8125C8.43743 2.66332 8.49669 2.52024 8.60218 2.41475C8.70767 2.30926 8.85075 2.25 8.99993 2.25C9.14912 2.25 9.29219 2.30926 9.39768 2.41475C9.50317 2.52024 9.56243 2.66332 9.56243 2.8125L9.56243 13.8298L13.6645 9.72703C13.77 9.62148 13.9132 9.56219 14.0624 9.56219C14.2117 9.56219 14.3549 9.62148 14.4604 9.72703C14.5659 9.83258 14.6252 9.97573 14.6252 10.125C14.6252 10.2743 14.5659 10.4174 14.4604 10.523L9.3979 15.5855C9.34566 15.6378 9.28362 15.6793 9.21533 15.7076C9.14705 15.7359 9.07385 15.7504 8.99993 15.7504C8.92601 15.7504 8.85281 15.7359 8.78453 15.7076C8.71624 15.6793 8.6542 15.6378 8.60196 15.5855Z"
                        fill="#DAD9D9"
                      />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {marketFilterOptions.map((item) => (
                      <Dropdown.Item
                        key={item}
                        className={`dropitem ${selectedMarketFilter === item ? "activeitem" : ""}`}
                        onClick={() => handleMarketFilterSelect(item)}
                      >
                        {item}
                        {selectedMarketFilter === item && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M21.5306 7.28062L9.53055 19.2806C9.4609 19.3503 9.37818 19.4057 9.28713 19.4434C9.19609 19.4812 9.09849 19.5006 8.99993 19.5006C8.90137 19.5006 8.80377 19.4812 8.71272 19.4434C8.62168 19.4057 8.53896 19.3503 8.4693 19.2806L3.2193 14.0306C3.07857 13.8899 2.99951 13.699 2.99951 13.5C2.99951 13.301 3.07857 13.1101 3.2193 12.9694C3.36003 12.8286 3.55091 12.7496 3.74993 12.7496C3.94895 12.7496 4.13982 12.8286 4.28055 12.9694L8.99993 17.6897L20.4693 6.21936C20.61 6.07863 20.8009 5.99957 20.9999 5.99957C21.199 5.99957 21.3898 6.07863 21.5306 6.21936C21.6713 6.36009 21.7503 6.55097 21.7503 6.74999C21.7503 6.94901 21.6713 7.13988 21.5306 7.28062Z"
                              fill="#E6FF00"
                            />
                          </svg>
                        )}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                <MyPredictedMarkets
                  activeKey={activeKey}
                  selectedMarketFilter={selectedMarketFilter}
                />
              </Tab>
              <Tab eventKey="Public Polls" title={t("Public Markets")}>
                <div className="tabsmain">
                  <div className={pools && pools?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"} style={isTableLoading ? { grid: "unset" } : {}}>
                    {isTableLoading ? (
                      <div className="pb-5 pt-5 text-center">
                        {
                          theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> :
                            <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                        }
                      </div>
                    ) : (
                      pools && pools.length > 0 ? (
                        pools.map((pool, index) => {
                          const volumeDecimal = convertFromWeiEthers(pool.totalVolume, pool?.token?.tokenDecimals);

                          return (
                            <a href={`/detail?id=${pool._id}`} className="inner-row" key={index}>
                              <div className="upper-area">
                                <p>
                                  {pool?.tags?.length > 0 ? (
                                    <>
                                      {pool.tags.slice(0, 2).join(", ")}
                                      {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                    </>
                                  ) : (
                                    t("")
                                  )}
                                </p>
                                <span className="livetext" style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[pool.status], color: MARKET_STATUS_TEXT_COLORS[pool.status], }}>{t(MARKET_STATUS[pool.status])}</span>
                              </div>
                              <h4 className="question-text">{truncateLongTexts(pool.question, 25)}</h4>
                              <div className="mid-options">
                                {renderOptions(
                                  pool.options,
                                  2,
                                  false,
                                  theme
                                )}
                              </div>
                              <div className="bottom-inline">
                                <div className="single-inline">
                                  <p>{t('Volume')}</p>
                                  <h6>{getTokenSymbol(pool?.token?.tokenSymbol)}{volumeDecimal ? formatNumberWithCommas(formatSmartDecimal(+volumeDecimal)) : "0"}</h6>
                                </div>
                                <div className="single-inline">
                                  <PoolTimerUI
                                    poolstart={pool?.startDate}
                                    poolend={pool?.endDate}
                                    poolsdetail={pool}
                                    setPollStatus={setPollStatus}
                                    setIsDisabled={setIsDisabled}
                                    endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                  />
                                </div>
                              </div>
                            </a>
                          );
                        })
                      ) : (
                        <div className="whennopolls">
                          <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                            <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                            <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                            <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                            <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                            <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                            <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                            <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                          </svg>
                          <p>{t('No Markets Found')}</p>
                        </div>
                      )
                    )}

                  </div>
                  {!isTableLoading &&
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  }
                </div>
              </Tab>
              <Tab
                eventKey="Private Polls"
                title={t("Private Markets")}
              >
                <div className="tabsmain">
                  <div className={pools && pools?.length > 0 ? "inner-tab-content" : "inner-tab-content nodatafoundstyling"} style={isTableLoading ? { grid: "unset" } : {}}>
                    {isTableLoading ? (
                      <div className="pb-5 pt-5 text-center">
                        {
                          theme === 'dark' ? <img width={50} className="mt-n4" src="/loader.svg" alt="img" /> :
                            <img width={50} className="mt-n4 loader_rotate" src="/loaderlight.svg" alt="img" />
                        }
                      </div>
                    ) : (
                      pools && pools.length > 0 ? (
                        pools.map((pool, index) => {
                          const volumeDecimal = convertFromWeiEthers(pool.totalVolume, pool?.token?.tokenDecimals);

                          return (
                            <a href={`/detail?id=${pool._id}`} className="inner-row" key={index}>
                              <div className="upper-area">
                                <p>
                                  {pool?.tags?.length > 0 ? (
                                    <>
                                      {pool.tags.slice(0, 2).join(", ")}
                                      {pool.tags.length > 2 && ` +${pool.tags.length - 2} More`}
                                    </>
                                  ) : (
                                    t("")
                                  )}
                                </p>
                                <span className="livetext" style={{ backgroundColor: MARKET_STATUS_BACKGROUNDS[pool.status], color: MARKET_STATUS_TEXT_COLORS[pool.status], }}>{t(MARKET_STATUS[pool.status])}</span>
                              </div>
                              <h4 className="question-text">{truncateLongTexts(pool.question, 25)}</h4>
                              <div className="mid-options">
                                {renderOptions(
                                  pool.options,
                                  2,
                                  false,
                                  theme
                                )}
                              </div>
                              <div className="bottom-inline">
                                <div className="single-inline">
                                  <p>{t('Volume')}</p>
                                  <h6>{getTokenSymbol(pool?.token?.tokenSymbol)}{volumeDecimal ? formatNumberWithCommas(formatSmartDecimal(+volumeDecimal)) : "0"}</h6>
                                </div>
                                <div className="single-inline">
                                  <PoolTimerUI
                                    poolstart={pool?.startDate}
                                    poolend={pool?.endDate}
                                    poolsdetail={pool}
                                    setPollStatus={setPollStatus}
                                    setIsDisabled={setIsDisabled}
                                    endedTextColor={theme === LIGHT_THEME ? "#212121" : "#FFFFFF"}
                                  />
                                </div>
                              </div>
                            </a>
                          );
                        })
                      ) : (
                        <div className="whennopolls">
                          <svg xmlns="http://www.w3.org/2000/svg" width="113" height="112" viewBox="0 0 113 112" fill="none">
                            <path d="M110.633 39.2002V42.9335L56.4996 61.6002L2.36625 42.9335V39.2002C2.36383 38.801 2.48942 38.4116 2.7246 38.0891C2.95977 37.7666 3.29214 37.5279 3.67291 37.4082L54.6329 21.0375L55.9209 20.6269C56.2956 20.4961 56.7035 20.4961 57.0782 20.6269L58.3662 21.0375L109.326 37.4082C109.707 37.5279 110.039 37.7666 110.275 38.0891C110.51 38.4116 110.635 38.801 110.633 39.2002Z" fill="#2F2F2F" />
                            <path d="M110.633 39.2002V89.0215C110.632 89.7987 110.389 90.5564 109.938 91.1888C109.486 91.8213 108.848 92.2969 108.113 92.5495L58.3662 109.704L57.7129 109.928C56.9283 110.208 56.0709 110.208 55.2862 109.928L54.6329 109.704L4.88625 92.5495C4.15123 92.2969 3.51338 91.8213 3.06164 91.1888C2.6099 90.5564 2.3668 89.7987 2.36625 89.0215V39.2002C2.36383 39.5993 2.48942 39.9888 2.7246 40.3113C2.95977 40.6338 3.29214 40.8725 3.67291 40.9922L54.7076 57.3815L55.9209 57.7735C56.2956 57.9043 56.7035 57.9043 57.0782 57.7735L58.2916 57.3815L109.326 40.9922C109.707 40.8725 110.039 40.6338 110.275 40.3113C110.51 39.9888 110.635 39.5993 110.633 39.2002Z" fill="#353535" />
                            <path d="M49.033 64.7736V97.2536C49.0323 97.5517 48.9606 97.8454 48.8239 98.1103C48.6871 98.3753 48.4893 98.6039 48.2467 98.7772C48.004 98.9505 47.7237 99.0635 47.4287 99.1069C47.1337 99.1503 46.8326 99.1229 46.5504 99.0269L11.0837 86.8002C10.7164 86.6718 10.3985 86.4319 10.1742 86.114C9.94999 85.796 9.8307 85.4159 9.83304 85.0269V53.3682C9.83326 53.0736 9.90321 52.7832 10.0372 52.5208C10.1712 52.2584 10.3653 52.0314 10.6038 51.8585C10.8424 51.6855 11.1184 51.5714 11.4095 51.5256C11.7005 51.4798 11.9983 51.5036 12.2784 51.5949L47.745 62.9816C48.1205 63.1076 48.4468 63.3484 48.6779 63.6699C48.909 63.9915 49.0333 64.3776 49.033 64.7736ZM103.166 53.3682V85.0269C103.169 85.4159 103.049 85.796 102.825 86.114C102.601 86.4319 102.283 86.6718 101.916 86.8002L66.449 99.0269C66.1668 99.1229 65.8657 99.1503 65.5707 99.1069C65.2758 99.0635 64.9954 98.9505 64.7527 98.7772C64.5101 98.6039 64.3123 98.3753 64.1755 98.1103C64.0388 97.8454 63.9671 97.5517 63.9664 97.2536V64.7736C63.9661 64.3776 64.0904 63.9915 64.3215 63.6699C64.5526 63.3484 64.8789 63.1076 65.2544 62.9816L100.721 51.5949C101.001 51.5036 101.299 51.4798 101.59 51.5256C101.881 51.5714 102.157 51.6855 102.396 51.8585C102.634 52.0314 102.828 52.2584 102.962 52.5208C103.096 52.7832 103.166 53.0736 103.166 53.3682Z" fill="#2F2F2F" />
                            <path d="M58.3671 21.0375V48.5335C58.3671 49.0286 58.1705 49.5034 57.8204 49.8535C57.4703 50.2035 56.9955 50.4002 56.5005 50.4002C56.0054 50.4002 55.5306 50.2035 55.1805 49.8535C54.8305 49.5034 54.6338 49.0286 54.6338 48.5335V21.0375L55.9218 20.6269C56.2965 20.4961 56.7044 20.4961 57.0791 20.6269L58.3671 21.0375Z" fill="#3E3E3E" />
                            <path d="M58.3666 57.8667V109.704L57.7132 109.928C56.9286 110.208 56.0712 110.208 55.2866 109.928L54.6332 109.704V57.8667C54.6292 57.7018 54.6545 57.5374 54.7079 57.3813L55.9212 57.7733C56.2959 57.9041 56.7039 57.9041 57.0786 57.7733L58.2919 57.3813C58.3453 57.5374 58.3706 57.7018 58.3666 57.8667Z" fill="#2F2F2F" />
                            <path d="M49.033 74.0881V77.9334C48.8368 77.9283 48.6422 77.8969 48.4543 77.8401L9.83301 65.4268V61.6001C10.0293 61.6038 10.2242 61.6352 10.4117 61.6934L49.033 74.0881ZM49.033 86.7441V90.5708C48.8376 90.5724 48.6429 90.5473 48.4543 90.4961L9.83301 78.0828V74.2561C10.0293 74.2598 10.2242 74.2912 10.4117 74.3494L49.033 86.7441ZM103.166 65.8561V69.6828L93.049 72.9308C92.7104 73.0606 92.4225 73.2958 92.2276 73.6016C92.0327 73.9074 91.9411 74.2677 91.9663 74.6294C91.9743 76.2444 91.4585 77.8183 90.4962 79.1153C89.5339 80.4122 88.1771 81.3623 86.6292 81.8228C85.0814 82.2834 83.4259 82.2297 81.9111 81.6698C80.3963 81.1099 79.1039 80.074 78.2277 78.7174C78.0255 78.4596 77.746 78.2733 77.4302 78.186C77.1144 78.0986 76.7789 78.1148 76.473 78.2321L64.5263 82.0401C64.3475 82.1072 64.1573 82.1389 63.9663 82.1334V78.3068L75.3343 74.6668C76.4212 74.2932 77.6008 74.2882 78.6908 74.6527C79.7807 75.0171 80.7201 75.7306 81.3637 76.6828C81.6988 77.2106 82.1622 77.6449 82.7106 77.9452C83.2589 78.2455 83.8745 78.402 84.4997 78.4001C85.4889 78.3971 86.4368 78.0029 87.1363 77.3034C87.8358 76.6039 88.23 75.656 88.233 74.6668C88.2 73.5064 88.5392 72.3659 89.2008 71.412C89.8625 70.4582 90.8119 69.741 91.9103 69.3654L102.588 65.9494C102.775 65.8912 102.97 65.8598 103.166 65.8561Z" fill="#3E3E3E" />
                            <path d="M56.5003 14.9333C56.0052 14.9333 55.5304 14.7367 55.1803 14.3866C54.8303 14.0365 54.6336 13.5617 54.6336 13.0667V1.86667C54.6336 1.3716 54.8303 0.896802 55.1803 0.546734C55.5304 0.196666 56.0052 0 56.5003 0C56.9953 0 57.4701 0.196666 57.8202 0.546734C58.1703 0.896802 58.3669 1.3716 58.3669 1.86667V13.0667C58.3669 13.5617 58.1703 14.0365 57.8202 14.3866C57.4701 14.7367 56.9953 14.9333 56.5003 14.9333ZM32.2336 18.6667C31.8851 18.6686 31.5431 18.5729 31.2462 18.3905C30.9493 18.208 30.7094 17.9461 30.5536 17.6344L24.9536 6.4344C24.7323 5.99131 24.6961 5.47846 24.8529 5.00867C25.0098 4.53888 25.3468 4.15063 25.7899 3.92933C26.233 3.70804 26.7458 3.67182 27.2156 3.82865C27.6854 3.98548 28.0737 4.32251 28.2949 4.7656L33.8949 15.9656C34.0368 16.2496 34.104 16.565 34.09 16.8821C34.0761 17.1993 33.9815 17.5076 33.8151 17.778C33.6488 18.0483 33.4163 18.2719 33.1396 18.4274C32.8629 18.5829 32.551 18.6652 32.2336 18.6667ZM80.7669 18.6667C80.4489 18.6665 80.1361 18.5851 79.8584 18.4301C79.5806 18.2751 79.3471 18.0517 79.1799 17.7811C79.0127 17.5105 78.9175 17.2017 78.9032 16.884C78.8889 16.5662 78.956 16.2501 79.0981 15.9656L84.6981 4.7656C84.9194 4.32251 85.3077 3.98548 85.7775 3.82865C86.2473 3.67182 86.7601 3.70804 87.2032 3.92933C87.6463 4.15063 87.9833 4.53888 88.1402 5.00867C88.297 5.47846 88.2608 5.99131 88.0395 6.4344L82.4395 17.6344C82.2843 17.945 82.0455 18.2061 81.7501 18.3885C81.4546 18.5708 81.1142 18.6672 80.7669 18.6667Z" fill="#393939" />
                          </svg>
                          <p>{t('No Markets Found')}</p>
                        </div>
                      )
                    )}

                  </div>
                  {!isTableLoading &&
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageChange}
                    />
                  }
                </div>
              </Tab> */}
              <Tab
                eventKey="History"
                title={t("Activity")}
              >
                <div className="bottom-new-twice-section">
                  {window.innerWidth > 991 ? (
                    <div className="history-section">
                      {/* <h4 className="heading-text">{t('My Positions')}</h4> */}
                      <div className="parent">
                        <div className="upper-fields">
                          <p>{t('Tx Hash')}</p>
                          <p>{t('Position Opened')}</p>
                          <p>{t('Amount')}</p>
                          {/* <p>Block Number</p> */}

                          {/* <p>Outcome</p> */}
                          <p>{t('Realized PnL')}</p>
                        </div>

                        <div className="bottom-fields" style={{ minHeight: "400px" }}>
                          {account ? (
                            mergedBetHistory && mergedBetHistory.length > 0 ? (
                              mergedBetHistory.map((bet, i) => {
                                const amountInEther = parseFloat(
                                  web3?.utils?.fromWei(String(bet?.amount), "mwei")
                                );
                                const finalAmount = amountInEther
                                let payout
                                if (bet.type === "win") {
                                  let payOut = web3?.utils?.fromWei(String(bet?.settlement), "mwei")
                                  payout = (+payOut) - (+finalAmount)
                                } else {
                                  payout = amountInEther

                                }
                                return (
                                  <div className="single-field" key={i}>
                                    {/* Transaction Hash + Link */}
                                    <a
                                      href={`${arbiscan_url}/${bet.transactionHash}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {shortenAddress(bet.transactionHash)}{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <path
                                          d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                          stroke="#797979"
                                          strokeWidth="1.04"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M10.5 1.5L6 6"
                                          stroke="#797979"
                                          strokeWidth="1.04"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M7.5 1.5H10.5V4.5"
                                          stroke="#797979"
                                          strokeWidth="1.04"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </a>

                                    {/* Timestamp */}
                                    <h6 style={{ flexDirection: "column", alignItems: "flex-start" }}>
                                      {
                                        epochToDateFormate(bet.blockTimestamp, true)
                                      }
                                      <span className="datetext">{
                                        epochToDateFormate(bet.blockTimestamp)
                                      }</span>
                                    </h6>

                                    {/* Bet Amount */}

                                    <h6>
                                      ${formatSmartDecimal(finalAmount)}</h6>

                                    {/* Block Number */}
                                    {/* <h6>{bet.blockNumber}</h6> */}



                                    {/* Win/Loss */}
                                    {/* <h6
                                  className={
                                    bet.type === "win" ? "green" : "red"
                                  }
                                >
                                  {bet.type === "win" ? "Profit" : "Loss"}
                                </h6> */}

                                    {/* Payout */}

                                    <h6
                                      className={
                                        bet.type === "win" ? "green" : "red"
                                      } >
                                      {bet.type === "win" ? "+" : "-"}
                                      ${formatSmartDecimal(payout)}</h6>
                                  </div>
                                );
                              })
                            ) : (
                              // No bets yet
                              <div className="connectwalletmain w-100">
                                <div className="mainimg">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                                    <path d="M3.5 3.5L38.5 38.5" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M14.6124 4.70799C17.781 3.47043 21.2416 3.18318 24.5709 3.88137C27.9001 4.57956 30.9538 6.23292 33.3582 8.6392C35.7626 11.0455 37.4136 14.1004 38.1092 17.4302C38.8049 20.76 38.5149 24.2204 37.2749 27.388" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M33.3901 33.3899C31.7631 35.0169 29.8314 36.3076 27.7056 37.1882C25.5797 38.0687 23.3012 38.522 21.0001 38.522C18.6991 38.522 16.4206 38.0687 14.2947 37.1882C12.1688 36.3076 10.2372 35.0169 8.61013 33.3899C6.98306 31.7628 5.69239 29.8312 4.81182 27.7053C3.93125 25.5794 3.47803 23.3009 3.47803 20.9999C3.47803 18.6988 3.93125 16.4203 4.81182 14.2944C5.69239 12.1686 6.98306 10.2369 8.61013 8.60986" stroke="#212121" stroke-width="2.0025" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </div>
                                <h6 className="connecthead">
                                  {t('No opened positions yet.')}
                                </h6>
                              </div>
                            )
                          ) : (
                            // Wallet not connected
                            <div className="connectwalletmain w-100">
                              <h6 className="connecthead">
                                {t("You Haven't Connected Your Wallet Yet")}
                              </h6>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="history-section-mbl w-100">
                      <div className="parent-cards">
                        {account ? (
                          mergedBetHistory && mergedBetHistory.length > 0 ? (
                            mergedBetHistory.map((bet, i) => {
                              const amountInEther = parseFloat(
                                web3?.utils?.fromWei(String(bet?.amount), "mwei")
                              );
                              const finalAmount =
                                amountInEther
                              let payout
                              if (bet.type === "win") {
                                let payOut = web3?.utils?.fromWei(String(bet?.settlement), "mwei")
                                payout = (+payOut) - (+finalAmount)
                              } else {
                                payout = amountInEther

                              }

                              return (
                                <div className="single-card" key={i}>
                                  {/* Tx Hash */}
                                  <div className="text">
                                    <p>{t('Tx Hash')}</p>
                                    <a
                                      href={`${arbiscan_url}/${bet.transactionHash}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {shortenAddress(bet.transactionHash)}{" "}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                      >
                                        <path
                                          d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                          stroke="#797979"
                                          strokeWidth="1.04"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M10.5 1.5L6 6"
                                          stroke="#797979"
                                          strokeWidth="1.04"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M7.5 1.5H10.5V4.5"
                                          stroke="#797979"
                                          strokeWidth="1.04"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </a>
                                  </div>

                                  <div className="text">
                                    <p>{t('Amount')}</p>
                                    <h6>${finalAmount ? formatSmartDecimal(finalAmount) : "0.00"}</h6>
                                  </div>

                                  <div className="text">
                                    <p>{t('Position Opened')}</p>
                                    <h6 style={{ flexDirection: "column", alignItems: "flex-start" }}>
                                      {
                                        epochToDateFormate(bet.blockTimestamp, true)
                                      }
                                      <span className="datetext">{
                                        epochToDateFormate(bet.blockTimestamp)
                                      }</span>

                                    </h6>
                                  </div>
                                  <div className="text">
                                    <p>{t('Realized PnL')}</p>
                                    <h6
                                      className={
                                        bet.type === "win" ? "green" : "red"
                                      } >
                                      {bet.type === "win" ? "+" : "-"}${formatSmartDecimal(payout)}</h6>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="connectwalletmain w-100">
                              <h6 className="connecthead">
                                {t("You Haven't Placed Any Position Yet")}
                              </h6>
                              <p className="connectpara">
                                {t('Your positions will show up here after you place one.')}
                              </p>
                            </div>
                          )
                        ) : (
                          <div className="connectwalletmain w-100">
                            <h6 className="connecthead">
                              {t("You Haven't Connect Your Wallet Yet")}
                            </h6>
                            <p className="connectpara">
                              {t('Click here to connect your wallet.')}
                            </p>
                          </div>

                        )}
                      </div>
                    </div>
                  )}
                  {/* {
              (window.innerWidth < 991 ? crashmbltab === "activity" : true) &&
              <Players
                gameState={gameState}
                winningsHistory={winningsHistory}
                setWinningsHistory={setWinningsHistory}
              />
            } */}
                </div>
                {/* <HistoryTable userHistory={pointsHistory} /> */}
              </Tab>
              {/* <Tab
                eventKey="Following"
                title={t("Following")}
              >
                <Following profileFollowing={profileFollowing} setProfileFollowing={setProfileFollowing} setFollowStats={setFollowStats} />
              </Tab>
              <Tab
                eventKey="Followers"
                title={t("Followers")}
              >
                <Followers profileFollowers={profileFollowers} />
              </Tab> */}
            </Tabs>
          </div>
        </div>
      </section>

      <Modal className="detail" show={show3} onHide={handleClose3} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("Select Winner")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="upper-heading">
            <h5>{t("Question")}</h5>
            <p>{poolsdetail?.question}</p>
          </div>
          <div className="uppercontent">
            <div className="mainboxxx">
              {poolsdetail?.options?.map((option, index) => {
                const totalSupplyLP =
                  percentageindiv && percentageindiv[index]
                    ? parseFloat(percentageindiv[index])
                    : 0;
                const divisionResult =
                  totalSupplyLP && totalSupplyLP !== 0
                    ? ((totalSupplyLP / percentageoption) * 100).toFixed(2)
                    : "0";
                return (
                  <div
                    key={option._id}
                    className={`innermainbox ${selectedOption === option.choiceIndex ? "active" : ""
                      }`}
                    onClick={() =>
                      handleOptionClick(option.choiceIndex, option?.optionName)
                    }
                  >
                    <div className="left">
                      <h6>{option.optionName}</h6>
                    </div>
                  </div>
                );
              })}
            </div>
            <p style={{ color: "var(--text-color1)" }}>{`Estimated ${NETWORK_FEES} $${gasEstimateInUsdt ? parseFloat(gasEstimateInUsdt)?.toFixed(4) : "0"}`}</p>
          </div>
          <div className="lastbutton">
            <button
              onClick={() =>
                handleContinue(poolsdetail?.contractAddress, poolsdetail?._id)
              }
            >
              {t("Continue")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal className="detail" show={show5} onHide={handleClose5} centered>
        <Modal.Body>
          <div className="innercontent">
            <div className="upperimg">
              {
                theme === 'dark' ? <img
                  src="\assets\greentick.png"
                  alt="img"
                  className="img-fluid tickimg"
                /> : <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
              }
            </div>
            <h2 className="upperheading">{t("Winner Successfully Decided")}</h2>
            <div className="winner-area">
              <p>{t("Winner")}</p>
              <h4>{selectedname}</h4>
            </div>
            <button
              className="ok"
              onClick={() => {
                handleClose5();
              }}
            >
              {t("Okay")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal className="detail" show={show6} onHide={handleClose6} centered>
        <Modal.Body>
          <div className="innercontent">
            <div className="upperimg">
              {
                theme === 'dark' ? <img
                  src="\assets\greentick.png"
                  alt="img"
                  className="img-fluid tickimg"
                /> : <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
              }
            </div>
            <h2 className="upperheading">{t("Market Closed")}</h2>
            <button
              className="ok"
              onClick={() => {
                handleClose6();
              }}
            >
              {t("Okay")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="detail editprofile-modal"
        backdrop="static"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Edit Profile")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="profile-content">
            <div className="main-profile">
              <div className="main-img">
                <img
                  src={profilepic || userprofile?.profilePic}
                  alt="Profile"
                  className="img-fluid"
                />
              </div>
              <div className="profile-detail">
                <h6>{t("Profile Image")}</h6>
                <p>
                  {t(
                    "We recommend uploading images in 400x400 resolution. Max 5 MB in JPEG or PNG format"
                  )}
                </p>
                <div className="twice-btns">
                  <label htmlFor="upload" className="btn-upload">
                    {t("Change")}
                  </label>
                  <a
                    href="#"
                    className="btn-remove"
                    onClick={(e) => {
                      e.preventDefault();
                      handleRemove();
                    }}
                  >
                    {t("Remove")}
                  </a>
                </div>
                <input
                  type="file"
                  className="d-none"
                  id="upload"
                  onChange={handleFileChange}
                />
              </div>
            </div>
            <div className="option-field">
              <label>{t("Full Name")}</label>
              <input
                type="text"
                placeholder={t("Full Name")}
                value={name}
                onChange={(e) => {
                  if (e.target.value.length <= 25) {
                    setName(e.target.value);
                  }
                }}
                maxLength={25}
              />
              <label className="mt-1">{name?.length}/25</label>
            </div>
            <div className="option-field">
              <label>{t("Wallet Address")}</label>
              <div className="inside-parent">
                <input
                  type="text"
                  value={getFormatedWeb3Address(smartAccount, true)}
                  placeholder={t("Wallet Address")}
                  readOnly
                />
                <a onClick={() => handleCopyClick11(smartAccount, true)}>
                  {isCopied ? (
                    <svg className="copysvg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M13 3L4.75 11L1 7.36364" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_635_6509)">
                        <path
                          d="M10.0005 4H5.00049C4.4482 4 4.00049 4.44772 4.00049 5V10C4.00049 10.5523 4.4482 11 5.00049 11H10.0005C10.5528 11 11.0005 10.5523 11.0005 10V5C11.0005 4.44772 10.5528 4 10.0005 4Z"
                          stroke="#E6FF00"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.00049 8C1.45049 8 1.00049 7.55 1.00049 7V2C1.00049 1.45 1.45049 1 2.00049 1H7.00049C7.55049 1 8.00049 1.45 8.00049 2"
                          stroke="#E6FF00"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_635_6509">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </a>
              </div>
            </div>
            <div className="option-field">
              <label>{t("Twitter Account (Url)")}</label>
              <input
                type="text"
                placeholder={t("Twitter Account")}
                value={twitterUrl}
                onChange={(e) => setTwitterUrl(e.target.value)}
              />
            </div>
            <div className="option-field">
              <label>{t("Telegram (Url)")}</label>
              <input
                type="text"
                placeholder={t("Telegram")}
                value={telegramUrl}
                onChange={(e) => setTelegramUrl(e.target.value)}
              />
            </div>
            <div className="option-field">
              <label>{t("Discord (Url)")}</label>
              <input
                type="text"
                placeholder={t("Discord")}
                value={DiscordUrl}
                onChange={(e) => setDiscordUrl(e.target.value)}
              />
            </div>
          </div>
          <div className="twice-btns">
            <a onClick={handleClose1} className="btn-cancel">
              {t("Cancel")}
            </a>
            <a onClick={() => handleUpdateProfile()} className="btn-save">
              {t("Save")}
            </a>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="round"
        show={show7}
        onHide={handleClose7}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body style={{ padding: "28px 22px" }}>

          <div className='maincontent'>
            <div className='mainimage'>
              {
                theme === 'dark' ? <img src='\assets\round.png' alt='img' className='img-fluid round round-moving-animation' /> :
                  <img src='\assets\roundlight.png' alt='img' className='img-fluid round round-moving-animation' />
              }
            </div>
            <h4>{message}</h4>
            <p className='paraplacing'>Transaction in progress! Blockchain validation is underway. This may take a few moments.</p>
            <ProgressiveProgressBar active={startProgressBar} />
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="detail changeresolver-modal"
        show={show8}
        onHide={handleClose8}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Change Resolver")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="innercontent innercontentcenteralign">
            <div className="upperimg">
              <img
                src="\assets\changeresovler.svg"
                alt="img"
                className="img-fluid tickimg"
              />
            </div>
            <h2 className="upperheading">{t("Are you sure")}?</h2>
            <p className="para">
              {t("You want to change resolver? This is irreversible")}
            </p>
            <div className="twice-btns">
              <a onClick={handleClose8} className="btn-cancel">
                {t("Cancel")}
              </a>
              <a className="btn-save">{t("Yes i’m Sure")}</a>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="detail changeresolver-modal"
        show={show9}
        onHide={handleClose9}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Change Resolver")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="innercontent">
            <label>{t("Enter Resolver Wallet Address")}</label>
            <div className="option-field">
              <input
                type="text"
                placeholder={t("Enter Wallet Address here...")}
              />
            </div>
            <div className="twice-btns">
              <a onClick={handleClose8} className="btn-cancel">
                {t("Cancel")}
              </a>
              <a className="btn-save">{t("Change Resolver")}</a>
            </div>
          </div>
        </Modal.Body>
      </Modal>



      <Modal className='common-modal-style withdrawmodal' show={showWithdraw} onHide={handleCloseWithdraw} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("Withdraw")}</Modal.Title>
        </Modal.Header>
        {IS_AQUA_SWAP_WITHDRAW_ACTIVE ?
          <Modal.Body>
            <div className='innercontent'>
              <div className='upperbox'>
                <p className='upperpara'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75ZM8.75 6.5625C8.75 6.37708 8.80499 6.19582 8.908 6.04165C9.01101 5.88748 9.15743 5.76732 9.32874 5.69636C9.50004 5.62541 9.68854 5.60684 9.8704 5.64301C10.0523 5.67919 10.2193 5.76848 10.3504 5.89959C10.4815 6.0307 10.5708 6.19775 10.607 6.3796C10.6432 6.56146 10.6246 6.74996 10.5536 6.92127C10.4827 7.09257 10.3625 7.23899 10.2084 7.342C10.0542 7.44502 9.87292 7.5 9.6875 7.5C9.43886 7.5 9.20041 7.40123 9.02459 7.22541C8.84878 7.0496 8.75 6.81114 8.75 6.5625Z" fill="#E27625" />
                </svg>{t("Only send to a USDT  address on the Arbitrum network")}</p>
              </div>

              <div className="mainboxes">
                <div className="innermainbox">
                  <p className="innerpara">{t("Token")}</p>
                  <Dropdown className="dropdown dropdowntokenitems">
                    <Dropdown.Toggle
                      id="dropdownMenuButton1"
                      className="d-flex align-items-center"

                    >
                      <div className="left-item d-flex align-items-center">
                        {tokenSelected?.key != DEFAULT_TOKEN &&
                          <img
                            src={tokenSelected?.icon}
                            alt="img"
                            className="img-fluid me-2"
                          />}
                        {tokenSelected?.key}
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="14"
                        viewBox="0 0 12 14"
                        fill="none"
                        className="ms-2"
                      >
                        <path
                          d="M5.60172 13.5855L0.539218 8.52297C0.43367 8.41742 0.374373 8.27427 0.374373 8.125C0.374373 7.97573 0.43367 7.83258 0.539218 7.72703C0.644766 7.62148 0.787919 7.56219 0.937187 7.56219C1.08645 7.56219 1.22961 7.62148 1.33516 7.72703L5.43719 11.8298L5.43719 0.8125C5.43719 0.663315 5.49645 0.520241 5.60194 0.414752C5.70743 0.309263 5.8505 0.25 5.99969 0.25C6.14887 0.25 6.29195 0.309263 6.39743 0.414752C6.50292 0.520242 6.56219 0.663315 6.56219 0.8125L6.56219 11.8298L10.6642 7.72703C10.7698 7.62148 10.9129 7.56219 11.0622 7.56219C11.2115 7.56219 11.3546 7.62148 11.4602 7.72703C11.5657 7.83258 11.625 7.97573 11.625 8.125C11.625 8.27427 11.5657 8.41742 11.4602 8.52297L6.39766 13.5855C6.34541 13.6378 6.28338 13.6793 6.21509 13.7076C6.1468 13.7359 6.07361 13.7504 5.99969 13.7504C5.92577 13.7504 5.85257 13.7359 5.78428 13.7076C5.716 13.6793 5.65396 13.6378 5.60172 13.5855Z"
                          fill="white"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {aquaTokens?.filter((tokens) =>
                        selectedChainWithdraw === CHAIN_BSC ? tokens?.key !== TOKEN_ETH : tokens?.key !== TOKEN_BNB
                      )?.slice(1)?.map((token) => (
                        <Dropdown.Item
                          key={token.key}
                          onClick={() => {
                            setSelectedTokenWithdraw(token.key);
                            aquaSwapAddress &&
                              handleAquaSwapWallet(token, getChainByKey(selectedChainWithdraw))
                          }}
                        >
                          <img
                            src={token?.icon}
                            alt="innertokenimg"
                            className="innertokenimg me-2"
                          />
                          {t(token?.key)}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="innermainbox">
                  <p className="innerpara">{t("Chain")}</p>
                  <Dropdown className="dropdowntokenitems">
                    <Dropdown.Toggle
                      id="dropdownMenuButton1"
                      className="d-flex align-items-center"
                    >
                      <div className="left-item d-flex align-items-center">
                        {chainSelected?.key != DEFAULT_CHAIN &&
                          <img
                            src={chainSelected?.icon}
                            alt="innertokenimg"
                            className="innertokenimg me-2"
                          />}
                        {chainSelected?.label}
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="14"
                        viewBox="0 0 12 14"
                        fill="none"
                        className="ms-2"
                      >
                        <path
                          d="M5.60172 13.5855L0.539218 8.52297C0.43367 8.41742 0.374373 8.27427 0.374373 8.125C0.374373 7.97573 0.43367 7.83258 0.539218 7.72703C0.644766 7.62148 0.787919 7.56219 0.937187 7.56219C1.08645 7.56219 1.22961 7.62148 1.33516 7.72703L5.43719 11.8298L5.43719 0.8125C5.43719 0.663315 5.49645 0.520241 5.60194 0.414752C5.70743 0.309263 5.8505 0.25 5.99969 0.25C6.14887 0.25 6.29195 0.309263 6.39743 0.414752C6.50292 0.520242 6.56219 0.663315 6.56219 0.8125L6.56219 11.8298L10.6642 7.72703C10.7698 7.62148 10.9129 7.56219 11.0622 7.56219C11.2115 7.56219 11.3546 7.62148 11.4602 7.72703C11.5657 7.83258 11.625 7.97573 11.625 8.125C11.625 8.27427 11.5657 8.41742 11.4602 8.52297L6.39766 13.5855C6.34541 13.6378 6.28338 13.6793 6.21509 13.7076C6.1468 13.7359 6.07361 13.7504 5.99969 13.7504C5.92577 13.7504 5.85257 13.7359 5.78428 13.7076C5.716 13.6793 5.65396 13.6378 5.60172 13.5855Z"
                          fill="white"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                      {aquaChains?.slice(1)?.map((chain) => (
                        <Dropdown.Item
                          key={chain?.key}
                          onClick={() => {
                            setSelectedChainWithdraw(chain?.key);
                          }}
                        >
                          <img
                            src={chain?.icon}
                            alt="innertokenimg"
                            className="innertokenimg me-2"
                          />
                          {chain?.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <div className='parentinputs'>
                <div className='innerinput'>
                  <p className='inputpara'>{t("Address")}</p>
                  <div className='maxbtnparent'>     <input value={withdrawalAddress} onChange={(e) => setWithdrawalAddress(e.target.value)} type='text' placeholder='0x...' /></div>

                </div>
                <div className='innerinput'>
                  <div className='upperhead'>
                    <div className='left'>
                      <p className='inputpara'>{t("Amount")}</p>
                    </div>
                    <div className='right'>
                      <p>{t("Balance")}:</p>
                      {withdrawalToken === TOKEN_USDT ? <p className='text'>   <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <g clip-path="url(#clip0_2489_26818)">
                          <path d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z" fill="#26A17B" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.52087 9.23468V9.23362C9.46243 9.23787 9.16121 9.25593 8.48918 9.25593C7.95262 9.25593 7.5749 9.24 7.44209 9.23362V9.23521C5.37659 9.14437 3.8349 8.78471 3.8349 8.3544C3.8349 7.92462 5.37659 7.56496 7.44209 7.47253V8.87715C7.57702 8.88671 7.96377 8.90956 8.49821 8.90956C9.13943 8.90956 9.46084 8.883 9.52087 8.87768V7.47359C11.5821 7.5655 13.1201 7.92515 13.1201 8.3544C13.1201 8.78471 11.5821 9.14331 9.52087 9.23468ZM9.52087 7.3275V6.07056H12.3971V4.15381H4.5659V6.07056H7.44209V7.32696C5.10459 7.43428 3.34668 7.89753 3.34668 8.45215C3.34668 9.00678 5.10459 9.4695 7.44209 9.57734V13.6053H9.52087V9.57628C11.8547 9.46896 13.6083 9.00625 13.6083 8.45215C13.6083 7.89806 11.8547 7.43534 9.52087 7.3275Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2489_26818">
                            <rect width="17" height="17" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                        {smartAccountUsdtBalance ? handleToFixedOnDecimals(smartAccountUsdtBalance) : "-"} USDT</p> : <p className='text'>    <img src="/assets/navbar/arbitrum.svg" alt="img" className="img-fluid" /> </p>}

                    </div>
                  </div>
                  <div className='maxbtnparent'>
                    <input value={handleToFixedOnDecimals(withdrawalAmount)} onChange={(e) => setWithdrawalAmount(e.target.value)} type='text' placeholder='0.00' />
                    <button
                      onClick={() => {
                        if (withdrawalToken !== TOKEN_USDT) return;

                        const gasEstimate = withdrawGasFeeEstimate || USDT_MOCK_VALUE;
                        const maxAmount = Math.max(
                          0,
                          parseFloat(smartAccountUsdtBalance) - parseFloat(gasEstimate)
                        );

                        setWithdrawalAmount(
                          handleToFixedOnDecimals(maxAmount.toString())
                        );
                      }}
                      className="max"
                    >
                      {t("MAX")}
                    </button>


                  </div>
                </div>
              </div>
              {aquaRequest ? <div className='upperbox'>
                <p className='upperpara'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75ZM8.75 6.5625C8.75 6.37708 8.80499 6.19582 8.908 6.04165C9.01101 5.88748 9.15743 5.76732 9.32874 5.69636C9.50004 5.62541 9.68854 5.60684 9.8704 5.64301C10.0523 5.67919 10.2193 5.76848 10.3504 5.89959C10.4815 6.0307 10.5708 6.19775 10.607 6.3796C10.6432 6.56146 10.6246 6.74996 10.5536 6.92127C10.4827 7.09257 10.3625 7.23899 10.2084 7.342C10.0542 7.44502 9.87292 7.5 9.6875 7.5C9.43886 7.5 9.20041 7.40123 9.02459 7.22541C8.84878 7.0496 8.75 6.81114 8.75 6.5625Z" fill="#E27625" />
                </svg>{aquaResponseMessage}</p>
              </div> : ""}

              <div className='lastbuttons'>
                <button className='close' onClick={() => {
                  handleCloseWithdraw();
                }}>{t("Close")}</button>
                <button disabled={withdrawalRequest || !withdrawalAddress || !withdrawalAmount || withdrawalAmount === "0" || tokenSelected?.key === DEFAULT_TOKEN || chainSelected?.key === DEFAULT_CHAIN} className='deposit' onClick={() => {
                  handleWithdrawFunds();
                }}>{withdrawalRequest ? <span className="spinner" /> : t("Withdraw")}</button>
              </div>
            </div>
          </Modal.Body>
          :
          <Modal.Body>
            <div className='innercontent'>
              <div className='upperbox'>
                <p className='upperpara'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM11.25 13.75C11.25 13.9158 11.1842 14.0747 11.0669 14.1919C10.9497 14.3092 10.7908 14.375 10.625 14.375C10.2935 14.375 9.97554 14.2433 9.74112 14.0089C9.5067 13.7745 9.375 13.4565 9.375 13.125V10C9.20924 10 9.05027 9.93415 8.93306 9.81694C8.81585 9.69973 8.75 9.54076 8.75 9.375C8.75 9.20924 8.81585 9.05027 8.93306 8.93306C9.05027 8.81585 9.20924 8.75 9.375 8.75C9.70652 8.75 10.0245 8.8817 10.2589 9.11612C10.4933 9.35054 10.625 9.66848 10.625 10V13.125C10.7908 13.125 10.9497 13.1908 11.0669 13.3081C11.1842 13.4253 11.25 13.5842 11.25 13.75ZM8.75 6.5625C8.75 6.37708 8.80499 6.19582 8.908 6.04165C9.01101 5.88748 9.15743 5.76732 9.32874 5.69636C9.50004 5.62541 9.68854 5.60684 9.8704 5.64301C10.0523 5.67919 10.2193 5.76848 10.3504 5.89959C10.4815 6.0307 10.5708 6.19775 10.607 6.3796C10.6432 6.56146 10.6246 6.74996 10.5536 6.92127C10.4827 7.09257 10.3625 7.23899 10.2084 7.342C10.0542 7.44502 9.87292 7.5 9.6875 7.5C9.43886 7.5 9.20041 7.40123 9.02459 7.22541C8.84878 7.0496 8.75 6.81114 8.75 6.5625Z" fill="#E27625" />
                </svg>{t(`Only send to a ${withdrawalToken}  address on the Arbitrum network`)}</p>
              </div>
              <div className="mainboxes">
                <div className="innermainbox">
                  <p className="innerpara">{t("Token")}</p>
                  <Dropdown className="dropdown dropdowntokenitems">
                    <Dropdown.Toggle className="dropdown-toggle" >
                      <div className="left-item">
                        <img src={withdrawalTokenImage} alt="img" className="img-fluid" />
                        {withdrawalToken}
                      </div>
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.8667 6.71141L8.32157 10.8778C8.27936 10.9165 8.22923 10.9473 8.17405 10.9682C8.11887 10.9892 8.05973 11 8 11C7.94027 11 7.88113 10.9892 7.82595 10.9682C7.77077 10.9473 7.72064 10.9165 7.67843 10.8778L3.1333 6.71141C3.06967 6.65314 3.02632 6.57888 3.00875 6.49801C2.99119 6.41715 3.00019 6.33333 3.03462 6.25715C3.06905 6.18098 3.12736 6.11589 3.20217 6.07011C3.27698 6.02434 3.36492 5.99994 3.45487 6H12.5451C12.6351 5.99994 12.723 6.02434 12.7978 6.07011C12.8726 6.11589 12.931 6.18098 12.9654 6.25715C12.9998 6.33333 13.0088 6.41715 12.9912 6.49801C12.9737 6.57888 12.9303 6.65314 12.8667 6.71141Z" fill="#212121" />
                      </svg> */}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => {
                        selectTokenToWithdraw(TOKEN_USDT, "/assets/usdticon.png");
                      }}>
                        <img src="/assets/usdticon.png" alt="USDT" className="img-fluid" style={{ width: "20px", marginRight: "8px" }} />
                        USDT
                      </Dropdown.Item>
                      {/* <Dropdown.Item onClick={() => {
                        selectTokenToWithdraw(TOKEN_RAIN, "/assets/rain-icon.svg");
                      }}>
                        <img src="/assets/rain-icon.svg" alt="RAIN" className="img-fluid" style={{ width: "20px", marginRight: "8px" }} />
                        RAIN
                      </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="innermainbox">
                  <p className="innerpara">{t("Chain")}</p>
                  <div className="innerbox">
                    <div className="tokenimg">
                      <img src="/assets/navbar/arbitrum.svg" alt="innertokenimg" className="innertokenimg" />
                    </div>
                    <p className="tokenpara">{t("Arbitrum")}</p>
                  </div>
                </div>
              </div>
              <div className='parentinputs'>
                <div className='innerinput'>
                  <p className='inputpara'>{t("Address")}</p>
                  <div className='maxbtnparent'>     <input value={withdrawalAddress} onChange={(e) => setWithdrawalAddress(e.target.value)} type='text' placeholder='0x...' /></div>

                </div>
                <div className='innerinput'>
                  <div className='upperhead'>
                    <div className='left'>
                      <p className='inputpara'>{t("Amount")}</p>
                    </div>
                    <div className='right'>
                      <p>{t("Balance")}:</p>
                      {withdrawalToken === TOKEN_USDT ? (
                        <p className='text'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <g clip-path="url(#clip0_2489_26818)">
                              <path d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z" fill="#26A17B" />
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.52087 9.23468V9.23362C9.46243 9.23787 9.16121 9.25593 8.48918 9.25593C7.95262 9.25593 7.5749 9.24 7.44209 9.23362V9.23521C5.37659 9.14437 3.8349 8.78471 3.8349 8.3544C3.8349 7.92462 5.37659 7.56496 7.44209 7.47253V8.87715C7.57702 8.88671 7.96377 8.90956 8.49821 8.90956C9.13943 8.90956 9.46084 8.883 9.52087 8.87768V7.47359C11.5821 7.5655 13.1201 7.92515 13.1201 8.3544C13.1201 8.78471 11.5821 9.14331 9.52087 9.23468ZM9.52087 7.3275V6.07056H12.3971V4.15381H4.5659V6.07056H7.44209V7.32696C5.10459 7.43428 3.34668 7.89753 3.34668 8.45215C3.34668 9.00678 5.10459 9.4695 7.44209 9.57734V13.6053H9.52087V9.57628C11.8547 9.46896 13.6083 9.00625 13.6083 8.45215C13.6083 7.89806 11.8547 7.43534 9.52087 7.3275Z" fill="white" />
                            </g>
                            <defs>
                              <clipPath id="clip0_2489_26818">
                                <rect width="17" height="17" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          {smartAccountUsdtBalance ? formatNumbers(+smartAccountUsdtBalance) : "-"} USDT
                        </p>
                      ) : withdrawalToken === TOKEN_RAIN ? (
                        <p className='text'>
                          <img src="/assets/rain-icon.svg" alt="RAIN" className="img-fluid" style={{ width: "17px", marginRight: "4px" }} />
                          {smartAccountRainBalance ? formatNumberWithCommas(smartAccountRainBalance) : "-"} RAIN
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className='maxbtnparent'>
                    <input
                      value={withdrawalAmount}
                      onChange={(e) => setWithdrawalAmount(e.target.value)}
                      type='number'
                      placeholder='0.00'
                    />
                    <button
                      onClick={() => {
                        if (withdrawalToken === TOKEN_USDT) {
                          const gasEstimate = withdrawGasFeeEstimate || USDT_MOCK_VALUE;
                          const maxAmount = Math.max(0, parseFloat(smartAccountUsdtBalance) - parseFloat(gasEstimate));
                          setWithdrawalAmount(handleToFixedOnDecimals(maxAmount.toString()));
                        } else if (withdrawalToken === TOKEN_RAIN) {
                          setWithdrawalAmount(handleToFixedOnDecimals(smartAccountRainBalance));
                        }
                      }}
                      className='max'
                    >
                      {t("MAX")}
                    </button>
                  </div>
                </div>
              </div>
              <div className='lastbuttons'>
                <button className='close' onClick={() => {
                  handleCloseWithdraw();
                }}>{t("Close")}</button>
                <button disabled={withdrawalRequest || !withdrawalAddress || !withdrawalAmount || withdrawalAmount === "0"} className='deposit' onClick={() => {
                  handleWithdrawFunds();
                }}>{withdrawalRequest ? <span className="spinner" /> : t("Withdraw")}</button>
              </div>
            </div>
          </Modal.Body>
        }
      </Modal>

      <Modal className='common-modal-style withdrawmodal' show={showFailed} onHide={handleCloseFailed} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("Error")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='innercontent'>
            <div className='uppermain'>
              <div className='mainimg'>
                <svg xmlns="http://www.w3.org/2000/svg" width="37" height="38" viewBox="0 0 37 38" fill="none">
                  <path d="M18.4997 34.4166C27.0141 34.4166 33.9163 27.5143 33.9163 18.9999C33.9163 10.4855 27.0141 3.58325 18.4997 3.58325C9.98528 3.58325 3.08301 10.4855 3.08301 18.9999C3.08301 27.5143 9.98528 34.4166 18.4997 34.4166Z" stroke="#522B0E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M18.5 9.75V19L24.6667 22.0833" stroke="#522B0E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <h6>{t("Withdrawal Failed")}</h6>
              <p className='paraerror'>{t("There are a lot of withdrawals happening right now and yours was unsuccessful due to high congestion. Please try again later or break your withdrawal down into smaller chunks of")} {withdrawalToken}</p>
              <span className="importantnote">
                {t("Note: Your")} {withdrawalToken} {t("is safe this congestion should subside shortly.")}
              </span>
              <button className='back' onClick={() => {
                handleCloseFailed();
                handleShowWithdraw();
              }}>{t("Back")}</button>
            </div>
          </div>
        </Modal.Body>

      </Modal>

      <Modal className='common-modal-style withdrawmodal' show={showComplete} onHide={handleCloseComplete} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("Success")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='innercontent'>
            <div className='uppermain'>
              {
                theme === 'dark' ? <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none" className='clock'>
                  <rect y="0.5" width="64" height="64" rx="32" fill="#99FF80" />
                  <path d="M48.9056 24.4461L28.4256 44.9261C28.3067 45.0451 28.1656 45.1395 28.0102 45.2039C27.8548 45.2683 27.6882 45.3015 27.52 45.3015C27.3518 45.3015 27.1852 45.2683 27.0298 45.2039C26.8745 45.1395 26.7333 45.0451 26.6144 44.9261L17.6544 35.9661C17.4142 35.7259 17.2793 35.4001 17.2793 35.0605C17.2793 34.7208 17.4142 34.3951 17.6544 34.1549C17.8946 33.9147 18.2203 33.7798 18.56 33.7798C18.8997 33.7798 19.2254 33.9147 19.4656 34.1549L27.52 42.2109L47.0944 22.6349C47.3346 22.3947 47.6603 22.2598 48 22.2598C48.3397 22.2598 48.6654 22.3947 48.9056 22.6349C49.1458 22.8751 49.2807 23.2008 49.2807 23.5405C49.2807 23.8801 49.1458 24.2059 48.9056 24.4461Z" fill="#111111" />
                </svg> : <img src='\assets\lightcheckmark.svg' alt='img' className='img-fluid tickimg' />
              }
              <h6>{t("Withdrawal Completed!")}</h6>
              <p className='paraaaa'>{t("Your funds")}<span> ({formatNumbers(+withdrawalAmount)} {withdrawalToken}) </span> {t("were successfully transferred")}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Offcanvas placement="bottom" className="tooltipoffcanvas" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            RAIN Points
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p>RAIN Points reflect your economic contribution to the platform.</p>
          <ul>
            <li>100 points = $1 in value</li>
            <li>Earn points by depositing funds, trading, adding liquidity, and inviting friends</li>
            <li> Points increase your share in airdrops and rewards</li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>


      <Modal show={showProfileModal} onHide={handleCloseShareProfileModal} centered className="pollmodal">
        <Modal.Body>
          <h6 className="modalhead mt-0" style={{ marginBottom: "28px" }}>{t("Share my profile")}</h6>
          <div className="socialicons">
            <div
              className="socialinner"
            >
              <span className="socialimg">
                <svg onClick={() => shareProfiletoSocials(twitter_url, userprofile?._id, userprofile?.name, userprofile?.walletAddress, formattedPNL, userprofile?.profilePic)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M13.6829 1.6875H16.1639L10.7437 7.8825L17.1202 16.3125H12.1274L8.21693 11.1997L3.74243 16.3125H1.25993L7.05743 9.68625L0.94043 1.6875H6.05993L9.59468 6.36075L13.6829 1.6875ZM12.8122 14.8275H14.1869L5.31293 3.0945H3.83768L12.8122 14.8275Z"
                    fill="#DAD9D9"
                  />
                </svg>
              </span>
              <p className="socialpara">{t("X")}</p>
            </div>
            <div
              className="socialinner"
            >
              <span className="socialimg">
                <svg
                  onClick={() => shareProfiletoSocials(facebook_url, userprofile?._id, userprofile?.name, userprofile?.walletAddress, formattedPNL, userprofile?.profilePic)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                >
                  <path
                    d="M10.8941 18V9.78996H13.6487L14.062 6.58941H10.8941V4.54632C10.8941 3.61998 11.1503 2.98869 12.4801 2.98869L14.1735 2.98799V0.125307C13.8807 0.0872508 12.8754 0 11.7054 0C9.2623 0 7.58968 1.49127 7.58968 4.22934V6.58941H4.82666V9.78996H7.58968V18H10.8941Z"
                    fill="#DAD9D9"
                  />
                </svg>
              </span>
              <p className="socialpara">{t("Facebook")}</p>
            </div>
            <div
              className="socialinner"
            >
              <span className="socialimg">
                <svg
                  onClick={() => shareProfiletoSocials(telegram_url, userprofile?._id, userprofile?.name, userprofile?.walletAddress, formattedPNL, userprofile?.profilePic)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M12.4312 7.06158C12.8912 6.58786 13.3479 5.4825 11.4311 6.82472C9.64055 8.09375 7.83781 9.34449 6.02317 10.5768C5.74685 10.7054 5.44812 10.7753 5.14493 10.7821C4.84174 10.7888 4.54035 10.7325 4.25886 10.6163C3.10877 10.261 1.76615 9.78724 1.76615 9.78724C1.76615 9.78724 0.849412 9.19422 2.41871 8.56259C2.41871 8.56259 9.05341 5.75884 11.3544 4.77105C12.2362 4.37628 15.2273 3.11301 15.2273 3.11301C15.2273 3.11301 16.6082 2.55947 16.4932 3.90255C16.4549 4.45523 16.1482 6.39133 15.8415 8.48363C15.3806 11.4453 14.8822 14.6841 14.8822 14.6841C14.8822 14.6841 14.8056 15.5921 14.1538 15.75C13.4562 15.7378 12.7821 15.4879 12.237 15.0394C12.0837 14.921 9.36094 13.1437 8.36336 12.2752C8.26185 12.2044 8.17942 12.1083 8.12367 11.9959C8.068 11.8835 8.04075 11.7583 8.04458 11.6322C8.04841 11.506 8.08317 11.383 8.14559 11.2743C8.20801 11.1658 8.2961 11.0751 8.40169 11.011C9.76997 9.72193 11.1133 8.40519 12.4312 7.06158Z"
                    fill="#DAD9D9"
                  />
                </svg>
              </span>
              <p className="socialpara">{t("Telegram")}</p>
            </div>
            <div
              className="socialinner"
            >
              <span className="socialimg">
                <svg
                  onClick={() => shareProfiletoSocials(whatsapp_url, userprofile?._id, userprofile?.name, userprofile?.walletAddress, formattedPNL, userprofile?.profilePic)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                >
                  <path
                    d="M8.99978 1.22021C4.43426 1.22021 0.71978 4.93469 0.71978 9.50021C0.71978 10.9258 1.08806 12.3277 1.78646 13.5646L0.7331 17.323C0.69854 17.4465 0.73202 17.579 0.8213 17.6708C0.89006 17.7417 0.98366 17.7802 1.07978 17.7802C1.10858 17.7802 1.13774 17.7766 1.16618 17.7698L5.08874 16.7981C6.28646 17.4411 7.63538 17.7802 8.99978 17.7802C13.5653 17.7802 17.2798 14.0657 17.2798 9.50021C17.2798 4.93469 13.5653 1.22021 8.99978 1.22021ZM13.165 12.422C12.9879 12.9123 12.1383 13.3598 11.73 13.4199C11.3635 13.4735 10.8999 13.4966 10.3908 13.3367C10.0823 13.2395 9.6863 13.1107 9.17906 12.8943C7.04678 11.9849 5.6543 9.86489 5.54774 9.72485C5.44154 9.58482 4.67978 8.58689 4.67978 7.55405C4.67978 6.52121 5.22878 6.01325 5.4239 5.80301C5.61902 5.59277 5.84906 5.54021 5.9909 5.54021C6.13274 5.54021 6.27422 5.54201 6.39842 5.54777C6.5291 5.55425 6.70442 5.49845 6.87686 5.90813C7.05398 6.32861 7.47914 7.36145 7.5317 7.46693C7.58498 7.57205 7.62026 7.69481 7.5497 7.83485C7.47914 7.97489 7.44386 8.06237 7.3373 8.18513C7.23074 8.30789 7.1141 8.45873 7.01834 8.55305C6.91178 8.65781 6.80126 8.77121 6.9251 8.98145C7.04894 9.19169 7.47554 9.87893 8.1077 10.4355C8.9195 11.1505 9.60458 11.3722 9.81698 11.4773C10.0294 11.5825 10.1536 11.5648 10.2774 11.4248C10.4013 11.2844 10.8088 10.8117 10.9503 10.6018C11.0917 10.3919 11.2336 10.4265 11.4287 10.4967C11.6238 10.5665 12.6689 11.0741 12.8813 11.1793C13.0937 11.2844 13.2355 11.3369 13.2888 11.4244C13.3421 11.5115 13.3421 11.932 13.165 12.422Z"
                    fill="#DAD9D9"
                  />
                </svg>
              </span>
              <p className="socialpara">{t("Whatsapp")}</p>
            </div>
            <div
              className="socialinner"
            >
              <span className="socialimg">
                <svg
                  onClick={() => shareProfileEmail(userprofile?.name, userprofile?._id, userprofile?.walletAddress, formattedPNL, userprofile?.profilePic)}
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clip-path="url(#clip0_77_470)">
                    <path
                      d="M10.5043 11.0283C10.0565 11.3268 9.53631 11.4847 9 11.4847C8.46373 11.4847 7.94355 11.3268 7.49573 11.0283L0.119848 6.11089C0.0789258 6.08361 0.0390586 6.05516 0 6.02591V14.0836C0 15.0075 0.749707 15.7406 1.65702 15.7406H16.3429C17.2668 15.7406 18 14.9909 18 14.0836V6.02588C17.9608 6.0552 17.9209 6.08371 17.8799 6.11103L10.5043 11.0283Z"
                      fill="#DAD9D9"
                    />
                    <path
                      d="M0.704883 5.23321L8.08077 10.1507C8.35998 10.3368 8.67997 10.4299 8.99996 10.4299C9.31999 10.4299 9.64002 10.3368 9.91923 10.1507L17.2951 5.23321C17.7365 4.93913 18 4.44694 18 3.91573C18 3.00234 17.2569 2.25928 16.3435 2.25928H1.65646C0.743098 2.25931 0 3.00237 0 3.91661C0 4.44694 0.263531 4.93913 0.704883 5.23321Z"
                      fill="#DAD9D9"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_77_470">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <p className="socialpara">{t("Email")}</p>
            </div>
            <div className="socialinner">
              <span className="socialimg">
                <a onClick={copyProfileLinks}>
                  {isCopied
                    ?
                    <svg className='copysvg' xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M13 3L5.75 11L1 7.36364" stroke="#E6FF00" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <g clip-path="url(#clip0_3462_5643)">
                        <path d="M8.76598 5.94484C8.61436 5.79231 8.44624 5.65711 8.26475 5.54171C7.78403 5.23389 7.22518 5.07032 6.65436 5.07032C5.86208 5.06884 5.10199 5.38364 4.54274 5.94484L1.82963 8.66007C1.27133 9.21945 0.957532 9.97734 0.957032 10.7676C0.955982 12.4168 2.29204 13.7546 3.94125 13.7557C4.7323 13.7584 5.49169 13.4451 6.05074 12.8854L8.29034 10.6458C8.33103 10.6055 8.35375 10.5505 8.35343 10.4932C8.35276 10.3754 8.2567 10.2804 8.13889 10.2811H8.05358C7.58567 10.2828 7.12193 10.1929 6.6885 10.0166C6.60864 9.98376 6.51686 10.0023 6.45602 10.0635L4.84563 11.6761C4.34557 12.1761 3.53482 12.1761 3.03476 11.6761C2.5347 11.176 2.5347 10.3652 3.03476 9.86518L5.75855 7.14355C6.25821 6.64451 7.06764 6.64451 7.5673 7.14355C7.90404 7.46046 8.42929 7.46046 8.76601 7.14355C8.91088 6.99855 8.99871 6.80623 9.01344 6.60177C9.02901 6.35744 8.9389 6.11815 8.76598 5.94484Z" fill="#DAD9D9" />
                        <path d="M12.8801 1.83023C11.7139 0.664013 9.82305 0.664013 8.65684 1.83023L6.41936 4.06555C6.35792 4.12729 6.3402 4.22015 6.37457 4.30018C6.40854 4.38045 6.48793 4.43196 6.57506 4.43029H6.65397C7.12134 4.42944 7.58433 4.51999 8.01693 4.69691C8.09679 4.72978 8.18857 4.71124 8.24941 4.65L9.85552 3.04601C10.3556 2.54595 11.1663 2.54595 11.6664 3.04601C12.1665 3.54607 12.1665 4.35682 11.6664 4.85688L9.66568 6.85545L9.64861 6.87465L8.94901 7.57C8.44935 8.06903 7.63992 8.06903 7.14026 7.57C6.80352 7.25308 6.27826 7.25308 5.94155 7.57C5.79575 7.7161 5.70784 7.91009 5.69412 8.11602C5.67852 8.36035 5.76863 8.59964 5.94155 8.77298C6.18843 9.02091 6.47728 9.2231 6.79472 9.3702C6.83951 9.39152 6.8843 9.40859 6.9291 9.42779C6.97389 9.44698 7.0208 9.46191 7.0656 9.47898C7.11039 9.49605 7.15731 9.51097 7.2021 9.52377L7.32795 9.55789C7.41326 9.57921 7.49859 9.59628 7.58603 9.6112C7.69136 9.62685 7.79744 9.63683 7.90385 9.64107H8.05314H8.06594L8.19392 9.62615C8.24084 9.62403 8.2899 9.61335 8.34537 9.61335H8.41788L8.56505 9.59203L8.63332 9.57924L8.75702 9.55364H8.78049C9.30442 9.42204 9.78283 9.15076 10.1648 8.76871L12.88 6.05347C14.0463 4.88725 14.0463 2.99644 12.8801 1.83023Z" fill="#DAD9D9" />
                      </g>
                      <defs>
                        <clipPath id="clip0_3462_5643">
                          <rect width="12.8" height="12.8" fill="white" transform="translate(0.956055 0.955566)" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                </a>
              </span>
              {/* <p className="socialpara">{t("Copied")}</p> */}
              <p className="socialpara">{t("Copy Link")}</p>

            </div>
          </div>
          <button onClick={handleCloseShareProfileModal} className="okaybtn">
            {t("Okay")}
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Mycreatedpolls;